import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Typography, Button, Select, Segmented, Progress, Skeleton, message, Spin, Tag } from 'antd';
import { LuStethoscope } from 'react-icons/lu';
import { generatePDF } from '../../../utils/pdfGenerator';
import AnalyticsReport from './AnalyticsReport';
import { 
    DownloadOutlined, 
    QrcodeOutlined, 
    PlayCircleOutlined, 
    ClockCircleOutlined, 
    CheckCircleOutlined, 
    EyeOutlined, 
    VideoCameraOutlined, 
    AudioOutlined, 
    SendOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    LineChartOutlined,
    BarChartOutlined,
    RadiusUpleftOutlined,
    MessageOutlined,
    BulbOutlined,
    LikeOutlined,
    LoadingOutlined,
    StarFilled,
    UsergroupAddOutlined,
    UserOutlined,
    FileTextOutlined,
    FallOutlined,
    RiseOutlined,
} from '@ant-design/icons';
import { Radar, Line, Bar, Column, Pie } from '@ant-design/charts';
import styled from 'styled-components';
import './AnalyticsPage.css';
import journey from '../../../services/journey';
import { notify } from '../../../utils/helper';
import { CustomButton } from '../physician_page/styled';
import { extractToken } from '../../../utils/localStorage';
import { globalRoles } from '../../../utils/roles';

import { groupService } from '../../../services/Group';
import { physicianService, ccmCoordinatorService, ccmManagerService } from '../../../services/user';
import { capitalizeFirstLetter } from '../../../utils/utils';

const { Title, Text } = Typography;

const PageWrapper = styled.div`
    padding: 40px 60px;
    background-color: var(--primary-bg);
    min-height: 100vh;

   .five-col {
      flex: 0 0 20%;
      max-width: 20%;
    }

    @media (max-width: 1200px) {
      .five-col {
        flex: 0 0 25%;   /* 4 per row */
        max-width: 25%;
      }
    }

    @media (max-width: 992px) {
      .five-col {
        flex: 0 0 33.33%; /* 3 per row */
        max-width: 33.33%;
      }
    }

    @media (max-width: 768px) {
      .five-col {
        flex: 0 0 50%; /* 2 per row */
        max-width: 50%;
      }
    }

    @media (max-width: 576px) {
      .five-col {
        flex: 0 0 100%; /* 1 per row */
        max-width: 100%;
      }
    }

    .ant-segmented {
      background-color: var(--border-color) !important;
    }
    .ant-segmented-thumb {
      background-color: var(--primary-bg);
    }
    .ant-segmented-item{
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--secondary-text-color) !important;

      &:hover {
        color: none !important;
      }
    }  
    .ant-segmented-item-selected{
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ant-segmented-item-label{
      font-size: 16px;
      font-weight: 600;
    }
    .ant-segmented-item-selected {
      background-color: var(--primary-bg) !important;
      color: var(--primary-text-color) !important;
    }

    .TopScheduler {
       text-align: center;
       padding: 40px;
       border-radius: 12px;
       border-color: var(--border-color);

       .textColor {
         color: var(--secondary-text-color) !important;
       }
    }
`;

const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    flex-wrap: wrap;
    row-gap: 12px;
`;

const TitleGroup = styled.div`
    h2 {
        margin-bottom: 4px !important;
        font-weight: 700;
        color: var(--primary-text-color);
    }
    span {
        color: var(--secondary-text-color);
        font-size: 17px;
    }
`;

const ActionsGroup = styled.div`
    display: flex;
    gap: 12px;
    
    // .ant-select-selector {
    //     border-radius: 8px !important;
    // }

    .ant-select {
      background-color: var(--primary-bg) !important;
      color: var(--primary-text-color);
      font-size: 16px;
    }
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
      background-color: var(--primary-bg) !important;
      border-color: var(--border-color) !important;
    }
    .ant-select-arrow {
      color: var(--primary-text-color);
    }
    .ant-select-item {
      background-color: var(--primary-bg) !important;
      color: var(--primary-text-color);
    }
    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      background-color: transparent !important;
    }
    .ant-select-item-option:hover:not(.ant-select-item-option-disabled) {
      background-color: var(--border-color) !important;
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: var(--border-color) !important;
      font-weight: 600;
    }

    .ant-select-dropdown {
      background-color: var(--primary-bg) !important;
      border: 1px solid var(--border-color) !important;
      border-radius: 6px;
    }

    .ant-select-selector {
      border-radius: 6px;
      height: 42px !important;
      align-items: center;
      border: 1px solid #8a3ef4;
    }

    .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
      border-color: #8a3ef4 !important;
    }
    
    .download-btn {
        background: #8a3ef4 !important;
        color: white !important;
        border: none !important;
        border-radius: 8px;
        display: flex;
        align-items: center;
        height: 32px;
        padding: 0 20px;
        font-weight: 600;
        font-size: 14px;
        
        &:hover {
            opacity: 0.9;
        }
    }
`;

const StatCardWrapper = styled(Card)`
    border-radius: 12px;
    border: 1px solid var(--border-color);
    // box-shadow: 0 2px 8px rgba(0,0,0,0.02);
    
    .ant-card-body {
        padding: 20px;
    }
`;

const StatHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    
    .stat-label {
        color: var(--primary-text-color);
        font-size: 14px;
        font-weight: 600;
    }
    
    .stat-icon {
        font-size: 20px;
        color: #8a3ef4;
    }
`;

const StatValue = styled.div`
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 4px;
    color: var(--primary-text-color);
`;

const StatTrend = styled.div`
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${props => props.type === 'up' ? '#52c41a' : '#ff4d4f'};
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    
    h4 {
        margin-bottom: 0 !important;
        font-weight: 700;
        color: var(--primary-text-color);
    }
    
    .section-icon {
        font-size: 20px;
        color: var(--secondary-text-color);
    }
`;

const SurveyQuestionContainer = styled.div`
    margin-top: 24px;
`;

const ReportingSummaryCard = styled(Card)`
    border-radius: 12px;
    border: 1px solid var(--border-color);
    background: var(--primary-bg);

    .ant-card-body {
        padding: 24px;
    }

    .report-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 8px;
        
        .report-icon {
            font-size: 20px;
            color: ${props => props.$isCcm ? '#10b981' : '#8a3ef4'};
        }
        
        h4 {
            margin: 0 !important;
            font-weight: 700;
            color: var(--primary-text-color);
        }
    }

    .report-subtitle {
        color: var(--secondary-text-color);
        font-size: 14px;
        margin-bottom: 24px;
        display: block;
    }

    .report-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        border-bottom: 1px solid var(--border-color);
        
        &:last-child {
            border-bottom: none;
        }

        .label {
            font-size: 16px;
            font-weight: 600;
            color: var(--primary-text-color);
        }

        .value {
            font-size: 18px;
            font-weight: 700;
        }
    }
`;

const ClinicalSummaryCard = styled.div`
    background: ${props => props.bgColor || '#f8fafc'};
    border: 1px solid ${props => props.borderColor || '#e2e8f0'};
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .summary-label {
        font-size: 14px;
        font-weight: 600;
        color: var(--secondary-text-color);
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .summary-value {
        font-size: 36px;
        font-weight: 700;
        color: ${props => props.color || '#0f172a'};
        line-height: 1.1;
    }

    .summary-subtext {
        font-size: 13px;
        color: var(--secondary-text-color);
        margin-top: 8px;
        font-weight: 500;
    }
`;

const QuestionHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
    
    .q-icon-box {
        width: 32px;
        height: 32px;
        background: rgba(138, 62, 244, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #8a3ef4;
        flex-shrink: 0;
    }
    
    .q-info {
        display: flex;
        flex-direction: column;
        
        .q-text {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 4px;
            color: var(--primary-text-color);
        }
        
        .q-stats {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 12px;
            
            .q-score {
                background: #fffbe6;
                color: #faad14;
                padding: 2px 8px;
                border-radius: 12px;
                font-weight: 600;
            }
            
            .q-responses {
                color: var(--secondary-text-color);
            }
        }
    }
`;

const maskEmail = (email) => {
    if (!email || !email.includes('@')) return '----';
    const [name, domain] = email.split('@');
    return `${name.charAt(0)}****@${domain}`;
};

const SchedulerCard = styled.div`
    background: var(--primary-bg);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;

    &:hover {
        border-color: #8a3ef4;
        box-shadow: 0 4px 12px rgba(138, 62, 244, 0.05);
    }

    .scheduler-info {
        display: flex;
        align-items: center;
        gap: 20px;
        flex: 1;
    }

    .rank-circle {
        width: 36px;
        height: 36px;
        background: #8a3ef4;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 14px;
        flex-shrink: 0;
    }

    .details {
        .name {
            font-size: 16px;
            font-weight: 700;
            color: var(--primary-text-color);
            margin-bottom: 2px;
        }
        .hospital {
            font-size: 13px;
            color: var(--secondary-text-color);
        }
    }

    .metrics {
        display: flex;
        gap: 48px;
        align-items: center;
    }

    .metric-item {
        text-align: center;
        min-width: 80px;

        .value {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 2px;
            line-height: 1;
        }
        .label {
            font-size: 11px;
            font-weight: 600;
            color: var(--secondary-text-color);
            text-transform: capitalize;
        }

        &.videos-sent .value { color: #8a3ef4; }
        &.patients .value { color: #3b82f6; }
        &.response-rate .value { color: #10b981; }
    }
`;

const VideoCard = styled.div`
    background: var(--primary-bg);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 16px 24px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;

    &:hover {
        border-color: #8a3ef4;
        box-shadow: 0 4px 12px rgba(138, 62, 244, 0.05);
    }

    .video-info {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .rank-circle {
        width: 32px;
        height: 32px;
        background: #8a3ef4;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 13px;
        flex-shrink: 0;
    }

    .details {
        .name {
            font-size: 15px;
            font-weight: 600;
            color: var(--primary-text-color);
            margin-bottom: 4px;
        }
        .meta {
            display: flex;
            align-items: center;
            gap: 12px;
            
            .specialty-tag {
                background: var(--primary-bg);
                color: var(--primary-text-color);
                border: 1px solid var(--border-color);
                padding: 2px 10px;
                border-radius: 20px;
                font-size: 11px;
                font-weight: 600;
                text-transform: capitalize;
            }
            .views {
                font-size: 12px;
                color: var(--secondary-text-color);
                font-weight: 500;
            }
        }
    }

    .rating {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 16px;
        font-weight: 700;
        color: var(--primary-text-color);
        
        .star-icon {
            color: #fbbf24;
            font-size: 18px;
        }
    }
`;

const OptionRow = styled.div`
    margin-bottom: 12px;
    
    .option-label-container {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        // margin-bottom: 4px;
        
        .option-name {
            font-weight: 700;
            color: var(--secondary-text-color);
        }
        
        .option-count {
            color: var(--secondary-text-color);
            font-size: 13px;
        }
    }
`;

const StatCard = ({ label, value, diff, icon: Icon }) => {
    const isPositive = diff > 0;
    const isNegative = diff < 0;
    const showTrend = diff !== 0;
    
    return (
        <StatCardWrapper className="stat-card">
            <StatHeader>
                <span className="stat-label">{label}</span>
                <Icon className="stat-icon" />
            </StatHeader>
            <StatValue>{value}</StatValue>
                <StatTrend type={isPositive ? 'up' : 'down'}>
                    {isPositive ? <RiseOutlined className='font-16' /> : <FallOutlined className='font-16' />}
                    {Math.abs(diff)}% from last month
                </StatTrend>
        </StatCardWrapper>
    );
};

const SurveyQuestion = ({ question, score, responses, options, icon: Icon }) => (
    <div className="survey-question-card">
        <QuestionHeader>
            <div className="q-icon-box">
                <Icon />
            </div>
            <div className="q-info">
                <div className="q-text">{question}</div>
                <div className="q-stats">
                    <span className="q-score">{score} / 5.0</span>
                    <span className="q-responses">{responses} responses</span>
                </div>
            </div>
        </QuestionHeader>
        
        {options.map((opt, idx) => (
            <OptionRow key={idx}>
                <div className="option-label-container">
                    <span className="option-name">{opt.label}</span>
                    <span className="option-count">{opt.count} ({opt.percent}%)</span>
                </div>
                <div className="progress-bar-container">
                    <div className="gradient-progress" style={{ width: `${opt.percent}%` }} />
                </div>
            </OptionRow>
        ))}
    </div>
);

const AnalyticsPage = () => {
    const user = extractToken();
    const isCCM = user?.role === globalRoles.CCM_COORDINATOR || user?.role === globalRoles.CCM_MANAGER;
    const isPhysician = user?.role === globalRoles.PHYSICIAN || user?.role === globalRoles.ASSISTANT;
    const isManager = user?.role === globalRoles.CCM_MANAGER;
    const isCoordinator = user?.role === globalRoles.CCM_COORDINATOR;
    const [selectedTab, setSelectedTab] = useState('Patient Survey');
    const [analyticsData, setAnalyticsData] = useState(null);
    const [dashboardAnalytics, setDashboardAnalytics] = useState({});
    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [monthlyComparison, setMonthlyComparison] = useState(null);
    const [engagementTrend, setEngagementTrend] = useState(null);
    const [clinicalVideos, setClinicalVideos] = useState([]);
    const [topSchedulers, setTopSchedulers] = useState([]);
    const [reportSummary, setReportSummary] = useState(null);
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [physicians, setPhysicians] = useState([]);
    const [selectedPhysician, setSelectedPhysician] = useState(null);
    const [viewType, setViewType] = useState(isPhysician ? 'physician_view' : isManager ? 'ccm_manager' : isCoordinator ? 'ccm_coordinator' : 'clinical_module');
    const [surveyTrends, setSurveyTrends] = useState(null);
    const [clinicalDashboardData, setClinicalDashboardData] = useState(null);
    const [ccmDashboardData, setCcmDashboardData] = useState(null);
    const [ccmManagerActivity, setCcmManagerActivity] = useState([]);
    const [ccmGroupPerformance, setCcmGroupPerformance] = useState([]);
    const [allCCMPerformance, setAllCCMPerformance] = useState([]);
    const [coordinators, setCoordinators] = useState([]);
    const [selectedCoordinator, setSelectedCoordinator] = useState(null);
    const [managers, setManagers] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    const [ccmGroups, setCcmGroups] = useState([]);
    const [selectedCcmGroup, setSelectedCcmGroup] = useState(null);
    const [physicianPerformance, setPhysicianPerformance] = useState([]);
    const [physicianIndividualPerformance, setPhysicianIndividualPerformance] = useState(null);
    const [coordinatorDashboardData, setCoordinatorDashboardData] = useState(null);

    const viewConfigs = {
        clinical_module: {
            title: 'Clinical Analytics Dashboard',
            subtitle: 'Clinical module analytics - Groups, Physicians, Schedulers'
        },
        clinical_lead: {
            title: 'Clinical Analytics Dashboard',
            subtitle: 'Clinical Group Lead - All physician analytics in your group'
        },
        physician_view: {
            title: 'Clinical Analytics Dashboard',
            subtitle: 'Physician-specific clinical analytics'
        },
        ccm_module: {
            title: 'CCM Analytics Dashboard',
            subtitle: 'CCM module analytics - Groups, Coordinators, Managers'
        },
        ccm_coordinator: {
            title: 'CCM Analytics Dashboard',
            subtitle: 'CCM Coordinator - Oversight of all CCM groups and managers'
        },
        ccm_group: {
            title: 'CCM Analytics Dashboard',
            subtitle: 'CCM Group - Analytics for a specific CCM group'
        },
        ccm_manager: {
            title: 'CCM Analytics Dashboard',
            subtitle: 'CCM Manager - Individual manager analytics'
        }
    };

    const currentConfig = viewConfigs[viewType] || viewConfigs.clinical;

    const handleDownloadPDF = async () => {
        try {
            setPdfLoading(true);
            
            // Build page list dynamically
            const pageIds = [
                'report-page-1',
                'report-page-1b', // Trends/Group page for all views
                ...(!viewType.includes('ccm') ? ['report-page-1c', 'report-page-1d'] : []), // Top Clinical Videos & Top Schedulers
                ...(viewType.includes('ccm') ? ['report-page-3', 'report-page-4'] : []), // CCM Activity by Manager & Group
                'report-page-5',
                'report-page-6',
                'report-page-7'
            ];
            
            await generatePDF(pageIds, `analytics-report.pdf`);
            notify("success", "Report downloaded successfully");
        } catch (error) {
            notify("error", "Failed to generate PDF report");
        } finally {
            setPdfLoading(false);
        }
    };

    const radarData = [
        { item: 'Q1', score: 4.0, fullText: 'After watching the video, how confident do you feel in understanding your upcoming procedure or care instructions?' },
        { item: 'Q2', score: 3.8, fullText: 'Would you recommend that other patients receive videos like this before their appointments?' },
        { item: 'Q3', score: 3.5, fullText: 'How helpful was the video in preparing you compared to written instructions or verbal explanations?' },
        { item: 'Q4', score: 4.5, fullText: 'Did the video make you more likely to follow through with your procedure, appointment, or care plan?' },
        { item: 'Q5', score: 4.2, fullText: 'Did watching the video reduce any anxiety or stress you had about your care?' },
    ];

//     {
//     "totalWatchTime": 7,
//     "totalViews": 35,
//     "totalClicks": 0,
//     "totalVideoSent": 17,
//     "totalVoiceRecordings": 13
// }

    const getRadarData = () => {
        if (!analyticsData?.perQuestion) return radarData;
        
        // Sort by questionNumber and map to radar format
        return [...analyticsData.perQuestion]
            .sort((a, b) => a.questionNumber - b.questionNumber)
            .map((q) => ({
                item: `Q${q.questionNumber}`,
                score: parseFloat(q.averageRating) || 0,
                fullText: q.question // Add question text for tooltip
            }));
    };

    const radarConfig = {
        data: getRadarData(),
        xField: 'item',
        yField: 'score',
        meta: {
            score: {
                alias: 'Average Score',
                min: 0,
                max: 5,
            },
        },
        xAxis: {
            line: null,
            tickLine: null,
            grid: {
                line: {
                    type: 'line',
                    style: {
                        lineDash: [4, 4],
                    },
                },
            },
        },
        yAxis: {
            label: false,
            grid: {
                alternateColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        area: {
            style: {
                fill: 'rgba(138, 62, 244, 0.3)',
            },
        },
        point: {
            size: 2,
        },
        tooltip: {
            fields: ['fullText', 'score', 'item'],
            formatter: (datum) => {
                return {
                    name: 'Score',
                    value: `${datum.score.toFixed(2)} / 5.0`,
                };
            },
            showTitle: true,
            title: (title) => {
                const currentData = getRadarData().find(d => d.item === title);
                return currentData?.fullText || title;
            },
            domStyles: {
                'g2-tooltip': {
                    padding: '20px',
                    borderRadius: '12px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    backgroundColor: '#ffffff',
                    border: 'none'
                },
                'g2-tooltip-title': {
                    width: '300px',
                    whiteSpace: 'normal',
                    marginBottom: '12px',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    color: '#334155'
                },
                'g2-tooltip-list-item': {
                    color: '#8a3ef4',
                    fontWeight: '700',
                    fontSize: '16px',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center'
                },
                'g2-tooltip-marker': {
                    display: 'none'
                }
            }
        },
        color: '#8a3ef4',
        autoFit: true,
    };

    const getEngagementTrendsData = () => {
        if (engagementTrend && Array.isArray(engagementTrend) && engagementTrend.length > 0) {
            const data = [];
            engagementTrend.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.videosSent || 0, type: 'Sent' });
                data.push({ month: monthLabel, value: item.videosClicked || 0, type: 'Clicked' });
                data.push({ month: monthLabel, value: item.videosWatched || 0, type: 'Completed' });
                data.push({ month: monthLabel, value: item.surveyCount || 0, type: 'Surveys' });
            });
            return data;
        }

        const months = ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb'];
        const data = [];
        
        // Data matching the wave pattern but with more realistic numbers if no real data is present
        const trends = {
            'Sent': [21, 39, 48, 33, 52, 27],
            'Clicked': [17, 31, 40, 28, 43, 18],
            'Completed': [13, 24, 29, 18, 31, 13],
            'Surveys': [8, 11, 18, 7, 17, 8]
        };

        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const trendsConfig = {
        data: getEngagementTrendsData(),
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        smooth: true,
        animation: true,
        legend: {
            position: 'bottom',
            itemName: {
                style: (item) => {
                    const colors = {
                        'Sent': '#8a3ef4',
                        'Clicked': '#6366f1',
                        'Completed': '#10b981',
                        'Surveys': '#f59e0b'
                    };
                    return {
                        fill: colors[item.name] || '#8a3ef4',
                        fontSize: 14,
                        fontWeight: 500
                    };
                }
            },
            marker: {
                symbol: (name) => {
                    return 'circle';
                },
                style: (item) => {
                    const colors = {
                        'Sent': '#8a3ef4',
                        'Clicked': '#6366f1',
                        'Completed': '#10b981',
                        'Surveys': '#f59e0b'
                    };
                    const color = colors[item.name] || '#8a3ef4';
                    return {
                        fill: 'white',
                        stroke: color,
                        lineWidth: 2,
                        r: 4,
                    };
                }
            }
        },
        color: ['#8a3ef4', '#6366f1', '#10b981', '#f59e0b'],
        point: {
            size: 4,
            shape: 'circle',
            style: (datum) => {
                const colors = {
                    'Sent': '#8a3ef4',
                    'Clicked': '#6366f1',
                    'Completed': '#10b981',
                    'Surveys': '#f59e0b'
                };
                return {
                    fill: 'white',
                    stroke: colors[datum.type] || '#8a3ef4',
                    lineWidth: 2,
                };
            },
        },
        lineStyle: (datum) => {
            const colors = {
                'Sent': '#8a3ef4',
                'Clicked': '#6366f1',
                'Completed': '#10b981',
                'Surveys': '#f59e0b'
            };
            return {
                stroke: colors[datum.type] || '#8a3ef4',
                lineWidth: 2,
            };
        },
        xAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 14,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        yAxis: {
            min: 0,
            nice: true,
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 14,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
    };

    const funnelData = [
        { type: 'Videos Sent', value: dashboardAnalytics?.totalVideoSent || 0 },
        { type: 'Videos Clicked', value: dashboardAnalytics?.totalClicks || 0 },
        { type: 'Videos Completed', value: dashboardAnalytics?.totalViews || 0 },
        { type: 'Surveys Completed', value: dashboardAnalytics?.surveyCount || 0 },
    ];

    const funnelConfig = {
        data: funnelData,
        xField: 'value',
        yField: 'type',
        seriesField: 'type',
        color: ['#8a3ef4', '#6366f1', '#3b82f6', '#10b981'],
        legend: false,
        smooth: true,
        animation: true,
        label: {
            position: 'middle',
            style: {
                fill: '#fff',
                fontWeight: 600,
            },
        },
        xAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 12,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        yAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 12,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        barStyle: {
            radius: [0, 4, 4, 0],
        },
    };

    // CCM Videos Sent & Enrolled Data
    const getCCMEngagementData = () => {
        if (engagementTrend && Array.isArray(engagementTrend) && engagementTrend.length > 0) {
            const data = [];
            engagementTrend.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.videosSent || 0, type: 'Sent' });
                data.push({ month: monthLabel, value: item.patientsEnrolled || 0, type: 'Enrolled' });
            });
            return data;
        }

        // fallback data
        const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const data = [];
        const trends = {
            'Sent': [96, 190, 160, 205, 188, 126],
            'Enrolled': [42, 38, 36, 46, 42, 28]
        };
        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const ccmEngagementConfig = {
        data: getCCMEngagementData(),
        isGroup: true,
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        color: ['#10b981', '#8a3ef4'],
        legend: { position: 'bottom' },
        columnStyle: { radius: [4, 4, 0, 0] },
    };

    // CCM Videos Sent & Enrollment by Group Data
    const getCCMGroupEngagementData = () => {
        if (ccmGroupPerformance && Array.isArray(ccmGroupPerformance) && ccmGroupPerformance.length > 0) {
            const data = [];
            ccmGroupPerformance.forEach((group) => {
                const groupName = group.groupName || 'Unknown Group';
                data.push({ group: groupName, value: group.videosSent || 0, type: 'Videos Sent' });
                data.push({ group: groupName, value: group.patientsEnrolled || 0, type: 'Patients Enrolled' });
            });
            return data;
        }
        
        // Fallback to static data if API data is not available
        const groups = [
            'Cardiac Care Group',
            'Endocrine Specialists',
            'Pulmonary Partners',
            'Renal Health Group',
            'Rheumatology Unit',
            'Senior Care Network'
        ];
        const data = [];
        const videosSent = [145, 118, 96, 82, 65, 138];
        const patientsEnrolled = [48, 36, 28, 24, 18, 42];
        
        groups.forEach((group, index) => {
            data.push({ group, value: videosSent[index], type: 'Videos Sent' });
            data.push({ group, value: patientsEnrolled[index], type: 'Patients Enrolled' });
        });
        return data;
    };

    const ccmGroupEngagementConfig = {
        data: getCCMGroupEngagementData(),
        isGroup: true,
        xField: 'group',
        yField: 'value',
        seriesField: 'type',
        color: ['#8a3ef4', '#10b981'],
        legend: { position: 'bottom' },
        columnStyle: { radius: [4, 4, 0, 0] },
        xAxis: {
            label: {
                autoRotate: true,
                autoHide: false,
                style: {
                    fontSize: 11,
                },
            },
        },
    };

    // CCM Patient Enrollment by Group - Pie Chart Data
    const getCCMEnrollmentPieData = () => {
        if (ccmGroupPerformance && Array.isArray(ccmGroupPerformance) && ccmGroupPerformance.length > 0) {
            return ccmGroupPerformance.map((group) => ({
                type: group.groupName || 'Unknown',
                value: group.patientsEnrolled || 0
            }));
        }
        
        // Fallback to static data if API data is not available
        return [
            { type: 'Cardiac Care', value: 23 },
            { type: 'Senior Care', value: 21 },
            { type: 'Endocrine Sp.', value: 18 },
            { type: 'Pulmonary Pa.', value: 15 },
            { type: 'Renal Health', value: 12 },
            { type: 'Rheumatology', value: 10 },
        ];
    };

    const ccmEnrollmentPieConfig = {
        data: getCCMEnrollmentPieData(),
        angleField: 'value',
        colorField: 'type',
        radius: 0.8,
        innerRadius: 0.6,
        color: ['#8a3ef4', '#6366f1', '#3b82f6', '#10b981', '#f59e0b', '#ef4444'],
        label: {
            type: 'outer',
            content: '{name} {percentage}',
            style: {
                fontSize: 12,
                fill: 'var(--primary-text-color)',
            },
        },
        legend: {
            position: 'bottom',
            itemName: {
                style: {
                    fill: 'var(--primary-text-color)',
                    fontSize: 12,
                },
            },
        },
        statistic: {
            title: {
                style: {
                    fontSize: '14px',
                    fill: 'var(--secondary-text-color)',
                },
                content: 'Total',
            },
            content: {
                style: {
                    fontSize: '24px',
                    fontWeight: 'bold',
                    fill: 'var(--primary-text-color)',
                },
                customHtml: () => {
                    const data = getCCMEnrollmentPieData();
                    const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
                    return `<div style="font-size: 24px; font-weight: bold; color: var(--primary-text-color);">${total}</div>`;
                },
            },
        },
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
        ],
    };

    // CCM Monthly Trends Data
    const getCCMMonthlyTrendsData = () => {
        if (engagementTrend && Array.isArray(engagementTrend) && engagementTrend.length > 0) {
            const data = [];
            engagementTrend.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.videosSent || 0, type: 'Videos Sent' });
                data.push({ month: monthLabel, value: item.videosClicked || item.videosWatched || 0, type: 'Videos Clicked' });
                data.push({ month: monthLabel, value: item.patientsEnrolled || 0, type: 'Patients Enrolled' });
                data.push({ month: monthLabel, value: item.surveyCount || 0, type: 'Surveys' });
            });
            return data;
        }

        // Fallback static data if API data is not available
        const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const data = [];
        const trends = {
            'Videos Sent': [125, 98, 88, 195, 178, 188],
            'Videos Clicked': [102, 85, 78, 118, 95, 132],
            'Patients Enrolled': [48, 36, 28, 42, 32, 38],
            'Surveys': [28, 32, 18, 32, 22, 28]
        };

        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const ccmMonthlyTrendsConfig = {
        data: getCCMMonthlyTrendsData(),
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        smooth: true,
        animation: true,
        legend: {
            position: 'bottom',
            itemName: {
                style: (item) => {
                    const colors = {
                        'Videos Sent': '#8a3ef4',
                        'Videos Clicked': '#3b82f6',
                        'Patients Enrolled': '#10b981',
                        'Surveys': '#f59e0b'
                    };
                    return {
                        fill: colors[item.name] || '#8a3ef4',
                        fontSize: 14,
                        fontWeight: 500
                    };
                }
            },
            marker: {
                symbol: 'circle',
                style: (item) => {
                    const colors = {
                        'Videos Sent': '#8a3ef4',
                        'Videos Clicked': '#3b82f6',
                        'Patients Enrolled': '#10b981',
                        'Surveys': '#f59e0b'
                    };
                    const color = colors[item.name] || '#8a3ef4';
                    return {
                        fill: 'white',
                        stroke: color,
                        lineWidth: 2,
                        r: 4,
                    };
                }
            }
        },
        color: ['#8a3ef4', '#3b82f6', '#10b981', '#f59e0b'],
        point: {
            size: 4,
            shape: 'circle',
            style: (datum) => {
                const colors = {
                    'Videos Sent': '#8a3ef4',
                    'Videos Clicked': '#3b82f6',
                    'Patients Enrolled': '#10b981',
                    'Surveys': '#f59e0b'
                };
                return {
                    fill: 'white',
                    stroke: colors[datum.type] || '#8a3ef4',
                    lineWidth: 2,
                };
            },
        },
        lineStyle: (datum) => {
            const colors = {
                'Videos Sent': '#8a3ef4',
                'Videos Clicked': '#3b82f6',
                'Patients Enrolled': '#10b981',
                'Surveys': '#f59e0b'
            };
            return {
                stroke: colors[datum.type] || '#8a3ef4',
                lineWidth: 2,
            };
        },
        xAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 14,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        yAxis: {
            min: 0,
            nice: true,
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 14,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
    };

    // Physician Comparison Chart Data
    const getPhysicianComparisonData = () => {
        if (physicianPerformance && Array.isArray(physicianPerformance) && physicianPerformance.length > 0) {
            const data = [];
            physicianPerformance.forEach((physician) => {
                const name = physician.name || physician.physicianName || 'Unknown';
                data.push({ physician: name, value: physician.videosSent || 0, type: 'Videos Sent' });
                data.push({ physician: name, value: physician.totalClicks || physician.clicks || 0, type: 'Clicks' });
                data.push({ physician: name, value: physician.completedCount || physician.completed || 0, type: 'Watched' });
            });
            return data;
        }
        return [];
    };

    // CCM Manager Performance Comparison Chart Data
    const getCCMManagerComparisonData = () => {
        if (allCCMPerformance && Array.isArray(allCCMPerformance) && allCCMPerformance.length > 0) {
            const data = [];
            allCCMPerformance.forEach((manager) => {
                const name = manager.name || 'Unknown';
                data.push({ manager: name, value: manager.videosSent || 0, type: 'Videos Sent' });
                data.push({ manager: name, value: manager.patientsManaged || 0, type: 'Patients Managed' });
                data.push({ manager: name, value: manager.surveysDone || 0, type: 'Surveys Completed' });
            });
            return data;
        }
        return [];
    };

    const getPhysicianComparisonConfig = () => ({
        data: getPhysicianComparisonData(),
        isGroup: true,  // Changed from isStack to isGroup for side-by-side bars
        xField: 'physician',
        yField: 'value',
        seriesField: 'type',
        color: ['#8a3ef4', '#3b82f6', '#10b981'],
        legend: { 
            position: 'bottom',
            itemName: {
                style: {
                    fill: 'var(--primary-text-color)',
                    fontSize: 13,
                    fontWeight: 500
                }
            }
        },
        columnStyle: { radius: [4, 4, 0, 0] },
        xAxis: {
            label: {
                autoRotate: false,
                autoHide: false,
                style: {
                    fill: '#64748b',
                    fontSize: 13,
                },
            },
        },
        yAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 13,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        tooltip: {
            shared: true,
            showMarkers: true,
        },
    });

    // CCM Manager Performance Comparison Config
    const getCCMManagerComparisonConfig = () => ({
        data: getCCMManagerComparisonData(),
        isGroup: true,
        xField: 'manager',
        yField: 'value',
        seriesField: 'type',
        color: ['#8a3ef4', '#10b981', '#f59e0b'],
        legend: { 
            position: 'bottom',
            itemName: {
                style: {
                    fill: 'var(--primary-text-color)',
                    fontSize: 13,
                    fontWeight: 500
                }
            }
        },
        columnStyle: { radius: [4, 4, 0, 0] },
        xAxis: {
            label: {
                autoRotate: false,
                autoHide: false,
                style: {
                    fill: '#64748b',
                    fontSize: 13,
                },
            },
        },
        yAxis: {
            label: {
                style: {
                    fill: '#64748b',
                    fontSize: 13,
                },
            },
            grid: {
                line: {
                    style: {
                        lineDash: [4, 4],
                        stroke: '#e2e8f0',
                    },
                },
            },
        },
        tooltip: {
            shared: true,
            showMarkers: true,
        },
    });

    // CCM Survey Trends Data
    const getCCMSurveyTrendsData = () => {
        if (surveyTrends && Array.isArray(surveyTrends) && surveyTrends.length > 0) {
            const data = [];
            surveyTrends.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.totalResponses || 0, type: 'Responses' });
                data.push({ month: monthLabel, value: item.averageScore || 0, type: 'Avg Score' });
            });
            return data;
        }

        const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const data = [];
        const trends = {
            'Responses': [19, 21, 27, 29, 22, 14],
            'Avg Score': [4.5, 4.2, 4.6, 4.0, 3.8, 4.2]
        };
        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const ccmSurveyTrendsConfig = {
        data: getCCMSurveyTrendsData(),
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        color: ['#10b981', '#f59e0b'],
        legend: { position: 'bottom' },
        smooth: true,
        point: { size: 4, shape: 'circle' },
    };

    // Clinical Videos Sent vs Completed Data
    const getClinicalEngagementData = () => {
        if (engagementTrend && Array.isArray(engagementTrend) && engagementTrend.length > 0) {
            const data = [];
            engagementTrend.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.videosSent || 0, type: 'Sent' });
                data.push({ month: monthLabel, value: item.videosWatched || 0, type: 'Completed' });
            });
            return data;
        }

        // Fallback data if API data is not available
        const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const data = [];
        const trends = {
            'Sent': [412, 282, 231, 204, 160, 396],
            'Completed': [198, 131, 121, 121, 82, 192]
        };
        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const clinicalEngagementConfig = {
        data: getClinicalEngagementData(),
        isGroup: true,
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        color: ['#8a3ef4', '#10b981'],
        legend: { position: 'bottom' },
        columnStyle: { radius: [4, 4, 0, 0] },
    };

    // Clinical Survey Trends Data
    const getClinicalSurveyTrendsData = () => {
        if (surveyTrends && Array.isArray(surveyTrends) && surveyTrends.length > 0) {
            const data = [];
            surveyTrends.forEach((item) => {
                const date = new Date(item.month);
                const monthLabel = date.toLocaleDateString('en-US', { month: 'short' });
                
                data.push({ month: monthLabel, value: item.totalResponses || 0, type: 'Responses' });
                data.push({ month: monthLabel, value: item.averageScore || 0, type: 'Avg Score' });
            });
            return data;
        }

        const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
        const data = [];
        const trends = {
            'Responses': [128, 60, 72, 81, 54, 88],
            'Avg Score': [4.8, 4.5, 4.2, 3.9, 4.6, 4.3]
        };
        months.forEach((month, index) => {
            Object.keys(trends).forEach(type => {
                data.push({ month, value: trends[type][index], type });
            });
        });
        return data;
    };

    const clinicalSurveyTrendsConfig = {
        data: getClinicalSurveyTrendsData(),
        xField: 'month',
        yField: 'value',
        seriesField: 'type',
        color: ['#8a3ef4', '#f59e0b'],
        legend: { position: 'bottom' },
        smooth: true,
        point: { size: 4, shape: 'circle' },
    };

    const statsData = [
        { 
            label: "Videos Sent", 
            value: `${dashboardAnalytics?.totalVideoSent || 0}`, 
            diff: dashboardAnalytics?.videoSentDiff || 0,
            icon: SendOutlined 
        },
        { 
            label: "Video Clicks", 
            value: `${dashboardAnalytics?.totalClicks || 0}`, 
            diff: dashboardAnalytics?.clicksDiff || 0,
            icon: LineChartOutlined 
        },
        { 
            label: "Avg Watch Time", 
            value: `${dashboardAnalytics?.totalWatchTime || 0} minutes`, 
            diff: dashboardAnalytics?.watchTimeDiff || 0,
            icon: ClockCircleOutlined 
        },
        { 
            label: "Video Views", 
            value: `${dashboardAnalytics?.totalViews || 0}`, 
            diff: dashboardAnalytics?.viewsDiff || 0,
            icon: EyeOutlined 
        },
        { 
            label: "Patient Surveys", 
            value: `${dashboardAnalytics?.surveyCount || 0}`, 
            diff: dashboardAnalytics?.surveyCountDiff || 0,
            icon: FileTextOutlined 
        },
    ];

    const getApiViewType = (v) => {
        return v;
    };

    const getSelectedUserId = () => {
        if (viewType === 'physician_view') return selectedPhysician?.id || user?.sub;
        if (viewType === 'clinical_lead') return selectedGroup?.owner;
        if (viewType === 'ccm_coordinator') return selectedCoordinator?.id || user?.sub;
        if (viewType === 'ccm_group') return undefined;
        if (viewType === 'ccm_manager') return selectedManager?._id || user?.sub;
        return undefined;
    };

    const getSelectedGroupId = () => {
        if (viewType === 'ccm_group') return selectedCcmGroup?._id || selectedCcmGroup?.id;
        return undefined;
    };

    const getDashboardAnalytics = async () => {
        try {
            setLoading(true);
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getDashboardAnalytics(apiViewType, userId, getSelectedGroupId());
            setDashboardAnalytics(res?.data);
        } catch (error) {
            console.error("Error fetching dashboard analytics:", error);
        } finally {
            setLoading(false);
        }
    };

    const getMonthlyComparison = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getMonthlyComparison(apiViewType, userId, getSelectedGroupId());
            setMonthlyComparison(res?.data);
        } catch (error) {
            console.error("Error fetching monthly comparison:", error);
        }
    };
    const getEngagementTrend = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getEngagementTrend(apiViewType, userId, getSelectedGroupId());
            setEngagementTrend(res?.data);
        } catch (error) {
            console.error("Error fetching engagement trend:", error);
        }
    };

    const getClinicalVideoView = async () => {
        try {
            const res = await journey.ClinicalVideoView();
            setClinicalVideos(res?.data?.topViewVideos || []);
        } catch (error) {
            console.error("Error fetching clinical video view:", error);
        }
    };

    const getTopScheduledVideoSent = async () => {
        try {
            const res = await journey.topScheduledVideoSent();
            setTopSchedulers(res?.data || []);
        } catch (error) {
            console.error("Error fetching top scheduled video sent:", error);
        }
    };

    const getGroups = async () => {
        try {
            const apiViewType = viewType === 'clinical_lead' && 'clinical'
            const res = await journey.getGroupLead(apiViewType);
            setGroups(res?.data?.groups || []);
            setSelectedGroup(res?.data?.groups?.[0] || null);
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    const getPhysicians = async () => {
        try {
            const res = await physicianService.getAll();
            const physiciansList = res?.data?.results || [];
            setPhysicians(physiciansList);
        } catch (error) {
            console.error("Error fetching physicians:", error);
        }
    };

    const getAssiatantData = async () => {
        try {
            const res = await journey.getAssiatantData(user?.sub);
            // const physiciansList = res?.data?.results || [];
            // setPhysicians(physiciansList);
            setSelectedPhysician(res?.data?.parent);
        } catch (error) {
            console.error("Error fetching physicians:", error);
        }
    };

    const getCoordinators = async () => {
        try {
            const res = await ccmCoordinatorService.getAll(0, 1, "", "", "");
            const coordinatorsList = res?.data?.results || [];
            setCoordinators(coordinatorsList);
            // Auto-select first coordinator by default
            if (coordinatorsList.length > 0) {
                setSelectedCoordinator(coordinatorsList[0]);
            }
        } catch (error) {
            console.error("Error fetching coordinators:", error);
        }
    };

    const getManagers = async () => {
        try {
            const res = await ccmManagerService.getAll(0, 1, "", "");
            const managersList = res?.data?.results || [];
            setManagers(managersList);
            // Auto-select first manager by default
            if (managersList.length > 0) {
                setSelectedManager(managersList[0]);
            }
        } catch (error) {
            console.error("Error fetching managers:", error);
        }
    };

    const getCcmGroups = async () => {
        try {
            const res = await groupService.getAll(100, 1, "", "", JSON.stringify([]));
            const results = res?.data?.hospitals?.results || res?.data?.results || [];
            const filtered = results.filter((g) => g.type === "ccm");
            setCcmGroups(filtered);
            if (filtered.length > 0) setSelectedCcmGroup(filtered[0]);
        } catch (error) {
            console.error("Error fetching CCM groups:", error);
        }
    };

    const getReportSummary = async () => {
        try {
            const apiViewType = getApiViewType(viewType);

            if (['clinical_module', 'ccm_module'].includes(apiViewType)) {
                const res = await journey.reportSummary(apiViewType);
                setReportSummary(res?.data);
            } else {
                const userId = getSelectedUserId();
                if (userId || getSelectedGroupId()) {
                    const res = await journey.reportSummary(apiViewType, userId, getSelectedGroupId());
                    setReportSummary(res?.data);
                }
            }
        } catch (error) {
            console.error("Error fetching report summary:", error);
        }
    };

    const getSurveyTrends = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getSurveyTrends(apiViewType, userId, getSelectedGroupId());
            setSurveyTrends(res?.data);
        } catch (error) {
            console.error("Error fetching report survey trends:", error);
        }
    };

    const getClinicalDashboardAnalytics = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getClinicalDashboardAnalytics(apiViewType, userId, getSelectedGroupId());
            setClinicalDashboardData(res?.data);
        } catch (error) {
            console.error("Error fetching clinical dashboard analytics:", error);
        }
    };

    const getCCMDashboardAnalytics = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getCCMDashboardAnalytics(apiViewType, userId, getSelectedGroupId());
            setCcmDashboardData(res?.data);
        } catch (error) {
            console.error("Error fetching CCM dashboard analytics:", error);
        }
    };

    const getCCMManagerActivity = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getCCMManagerActivity(apiViewType, userId, getSelectedGroupId());
            setCcmManagerActivity(res?.data || []);
        } catch (error) {
            console.error("Error fetching CCM dashboard analytics:", error);
        }
    };

    const getCoordinatorDashboard = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getCoordinatorDashboard(apiViewType, userId, getSelectedGroupId());
            setCoordinatorDashboardData(res?.data || null);
        } catch (error) {
            console.error("Error fetching coordinator dashboard:", error);
        }
    };

    const getPhysicianPerformance = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = viewType === 'clinical_lead' ? selectedGroup?.owner : 
                          viewType === 'physician_view' ? (selectedPhysician?.id || user?.sub) : 
                          undefined;
            const res = await journey.getPhysicianPerformance(apiViewType, userId);
            setPhysicianPerformance(res?.data || []);
        } catch (error) {
            console.error("Error fetching physician performance:", error);
        }
    };

    const getPhysicianIndividualPerformance = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = (selectedPhysician?.id || user?.sub);
            const res = await journey.getPhysicianIndividualPerformance(apiViewType, userId);
            setPhysicianIndividualPerformance(res?.data || null);
        } catch (error) {
            console.error("Error fetching physician individual performance:", error);
        }
    };

    const getCcmGroupPerformance = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getCcmGroupPerformance(apiViewType, userId, getSelectedGroupId());
            setCcmGroupPerformance(res?.data?.performance || []);
        } catch (error) {
            console.error("Error fetching CCM group performance:", error);
        }
    };
    const getAllCCMPerformance = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const res = await journey.getAllCCMPerformance(apiViewType, getSelectedUserId(), getSelectedGroupId());
            setAllCCMPerformance(res?.data || []);
        } catch (error) {
            console.error("Error fetching all CCM performance:", error);
        }
    };

    const DownloadCsv = async () => {
        try {
            const isSuperAdmin = user?.role === globalRoles.SUPERADMIN;
            const res = await journey.downloadCsv(isSuperAdmin ? getApiViewType(viewType) : undefined);
            if (res?.data) {
                // The server returns an Excel file (XLSX) despite the endpoint name
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'analytics_report.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        } catch (error) {
            console.error("Error downloading CSV:", error);
        }
    };


    const getSurveyAnalytics = async () => {
        try {
            const apiViewType = getApiViewType(viewType);
            const userId = getSelectedUserId();
            const res = await journey.getSurveyAnalytics(apiViewType, userId, getSelectedGroupId());
            setAnalyticsData(res?.data);
        } catch (error) {
            
        }
    };

    useEffect(() => {
        
        // Only call clinical video view for non-CCM views (not needed in physician_view)
        if (!viewType.includes('ccm') && viewType !== 'physician_view') {
            getClinicalVideoView();
        }
        
        // Only call top schedulers for clinical_module
        if (viewType === 'clinical_module') {
            getTopScheduledVideoSent();
        }
        
        // Load groups only for clinical_lead
        if(viewType === "clinical_lead"){
            getGroups();
        }
        
        // Load physicians only for physician_view
        if(viewType === "physician_view" && !isPhysician){
            getPhysicians();
        } 
        if(viewType === "physician_view" && user?.role === globalRoles.ASSISTANT) {
            getAssiatantData();
        }
        
        // Load coordinators only for ccm_coordinator
        if(viewType === "ccm_coordinator" && user?.role !== globalRoles.CCM_COORDINATOR){
            getCoordinators();
        }
        
        // Load CCM groups only for ccm_group
        if(viewType === "ccm_group"){
            getCcmGroups();
        }
        
        // Load managers only for ccm_manager
        if(viewType === "ccm_manager" && user.role !== globalRoles.CCM_MANAGER){
            getManagers();
        }
    }, [viewType]);

    useEffect(() => {
        // Always call these for all views
        getDashboardAnalytics();
        getMonthlyComparison();
        getEngagementTrend();
        getReportSummary();
        getSurveyTrends();
        // Always call survey analytics
        getSurveyAnalytics();
        
        // Call appropriate dashboard analytics based on viewType
        if (['clinical_module', 'clinical_lead'].includes(viewType)) {
            getClinicalDashboardAnalytics();
        } else if (['ccm_module', 'ccm_coordinator', 'ccm_group', 'ccm_manager'].includes(viewType)) {
            getCCMDashboardAnalytics();
            getCCMManagerActivity();
            getCcmGroupPerformance();
        }
        // Only call physician performance for clinical_lead when group is selected
        if (viewType === 'clinical_lead' && selectedGroup) {
            getPhysicianPerformance();
        }
        // Call physician individual performance for physician_view when physician is selected
        if (viewType === 'physician_view' && (selectedPhysician || user?.role === globalRoles.PHYSICIAN)) {
            getPhysicianIndividualPerformance();
        }
        if(['ccm_coordinator', 'ccm_group', 'ccm_manager'].includes(viewType)) {
            getCoordinatorDashboard();
        }
        if (['ccm_coordinator', 'ccm_group', 'ccm_manager'].includes(viewType)) {
            getAllCCMPerformance();
        }
    }, [viewType, selectedGroup, selectedPhysician, selectedCoordinator, selectedManager, selectedCcmGroup]);

    return (
        <PageWrapper id="analytics-dashboard-content">
            {/* Hidden Report Component - Only visible to PDF generator */}
            <div style={{ position: 'absolute', top: '-10000px', left: '-10000px' }}>
                <AnalyticsReport 
                    analyticsData={analyticsData} 
                    dashboardAnalytics={dashboardAnalytics} 
                    statsData={statsData}
                    radarConfig={radarConfig}
                    monthlyComparison={monthlyComparison}
                    engagementTrend={engagementTrend}
                    clinicalVideos={clinicalVideos}
                    topSchedulers={topSchedulers}
                    viewType={viewType}
                    selectedGroup={selectedGroup}
                    selectedPhysician={selectedPhysician}
                    ccmManagerActivity={ccmManagerActivity}
                    ccmGroupPerformance={ccmGroupPerformance}
                />
            </div>

            <HeaderSection>
                <TitleGroup>
                    <Title level={2}>{currentConfig.title}</Title>
                    <Text>{currentConfig.subtitle}</Text>
                </TitleGroup>
                <ActionsGroup>
                    {user?.role === globalRoles.SUPERADMIN && (
                    <Select 
                      value={viewType} 
                      getPopupContainer={triggerNode => triggerNode.parentNode} 
                      style={{ width: 220 }} 
                      onChange={(value) => {
                        setViewType(value);
                        setSelectedPhysician(null);
                        setSelectedGroup(null);
                      }}
                      className="view-selector"
                    >
                        <Select.Option value="clinical_module" style={{ fontWeight: 700, color: '#000' }}>Clinical Module</Select.Option>
                        <Select.Option value="clinical_lead">&nbsp;&nbsp;&nbsp;Clinical Group Lead</Select.Option>
                        <Select.Option value="physician_view">&nbsp;&nbsp;&nbsp;Physician View</Select.Option>
                        <Select.Option value="ccm_module" style={{ fontWeight: 700, color: '#000' }}>CCM Module</Select.Option>
                        <Select.Option value="ccm_coordinator">&nbsp;&nbsp;&nbsp;CCM Coordinator</Select.Option>
                        <Select.Option value="ccm_group">&nbsp;&nbsp;&nbsp;CCM Group</Select.Option>
                        <Select.Option value="ccm_manager">&nbsp;&nbsp;&nbsp;CCM Manager</Select.Option>
                    </Select>
                    )}
                    <CustomButton 
                        // className="download-btn"
                        onClick={handleDownloadPDF}
                        disabled={pdfLoading}
                    >
                        {pdfLoading ? 
                          <Spin style={{ display: "flex", marginRight: '8px', color: "#fff" }} indicator={<LoadingOutlined spin />} /> 
                        : <DownloadOutlined className='font-18' />}
                        Download {viewType.includes('ccm') ? 'CCM' : 'Clinical'} PDF
                    </CustomButton>
                    {(viewType.includes('ccm') || isCCM) && (
                    <CustomButton
                        onClick={DownloadCsv}
                    >
                        <DownloadOutlined className='font-18' />
                        CSV Download
                    </CustomButton>
                    )}
                </ActionsGroup>
            </HeaderSection>

            {/* <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                {loading ? (
                    Array.from({ length: 10 }).map((_, index) => (
                        <Col key={index} className="five-col">
                            <Card style={{ borderRadius: '12px', border: '1px solid var(--border-color)' }}>
                                <Skeleton active paragraph={{ rows: 2 }} title={false} />
                            </Card>
                        </Col>
                    ))
                ) : (
                    statsData.map((stat, index) => (
                        <Col key={index} className="five-col">
                            <StatCard 
                                label={stat.label} 
                                value={stat.value} 
                                diff={stat.diff} 
                                icon={stat.icon} 
                            />
                        </Col>
                    ))
                )}
            </Row> */}

            {viewType === 'clinical_lead' && (
                <div style={{ marginBottom: '32px' }}>
                    <Card 
                        style={{ 
                            borderRadius: '12px', 
                            border: '1px solid var(--border-color)', 
                            background: '#fff',
                            marginBottom: '24px'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <LuStethoscope style={{ fontSize: '24px', color: '#8a3ef4' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>Clinical Group Lead View</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: "var(--secondary-text-color)" }}>
                            Select your clinical group to see all physicians analytics under your leadership
                        </Text>
                        
                        <Select 
                            value={selectedGroup?._id}
                            style={{ width: '100%', marginBottom: '16px' }}
                            dropdownStyle={{ borderRadius: '8px' }}
                            onChange={(value) => {
                                const group = groups.find(g => g._id === value);
                                setSelectedGroup(group);
                            }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        >
                            {groups.map(group => (
                                <Select.Option key={group._id} value={group._id}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: 500 }}>{group.hospitalName}</span>
                                        <Tag color="default" style={{ borderRadius: '12px', background: '#f1f5f9', border: 'none' }}>{group.specialty[0] || 'General'}</Tag>
                                    </div>
                                </Select.Option>
                            ))}
                        </Select>
                        
                        <div style={{ display: 'flex', gap: '16px' }}>
                            <Text type="secondary" style={{color: "var(--secondary-text-color)"}}>Specialty: <Text strong style={{ color: 'var(--primary-text-color)' }}>{selectedGroup?.specialty[0] || 'N/A'}</Text></Text>
                            <Text type="secondary" style={{color: "var(--secondary-text-color)"}}>Physicians: <Text strong style={{ color: 'var(--primary-text-color)' }}>{selectedGroup?.totalPhysician || 0}</Text></Text>
                        </div>
                    </Card>
                </div>
            )}

            {viewType === 'physician_view' && (
                <div style={{ marginBottom: '32px' }}>
                    {!isPhysician && (
                    <Card 
                        style={{ 
                            borderRadius: '12px', 
                            border: '1px solid var(--border-color)', 
                            background: '#fff',
                            marginBottom: '24px'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <UserOutlined style={{ fontSize: '24px', color: '#8a3ef4' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>Select Physician</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: "var(--secondary-text-color)" }}>
                            Choose a physician to view their analytics
                        </Text>
                        
                        <Select 
                            value={selectedPhysician?.id || undefined}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ 
                                width: '100%', 
                                marginBottom: '16px'
                            }}
                            dropdownStyle={{ 
                                borderRadius: '8px',
                                backgroundColor: 'var(--primary-bg)',
                                border: '1px solid var(--border-color)'
                            }}
                            onChange={(value) => {
                                const physician = physicians.find(p => p.id === value);
                                if (physician) {
                                    setSelectedPhysician(physician);
                                } else {
                                    console.error("Available IDs:", physicians.map(p => p._id));
                                }
                            }}
                            placeholder="Choose a physician..."
                            showSearch
                            filterOption={(input, option) => {
                                const text = option.children;
                                if (typeof text === 'string') {
                                    return text.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }}
                            notFoundContent="No physicians available"
                            loading={physicians.length === 0}
                        >
                            {physicians.map(physician => (
                                <Select.Option key={physician.id} value={physician.id}>
                                    {physician.name} - {physician.specialty || 'General'}
                                </Select.Option>
                            ))}
                        </Select>
                    </Card>
                    )}
                    
                    {user?.role !== globalRoles.PHYSICIAN && (
                    selectedPhysician ? (
                        <Card 
                            style={{ 
                                borderRadius: '12px', 
                                border: '1px solid var(--border-color)', 
                                background: '#fff'
                            }}
                        >
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>{selectedPhysician.name}</Title>
                            <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>
                                {selectedPhysician.specialty || 'General'} - {selectedPhysician.hospitalName || 'General Hospital'}
                            </Text>
                        </Card>
                    ) : (
                        <Card 
                            style={{ 
                                borderRadius: '12px', 
                                border: '1px solid var(--border-color)', 
                                background: '#fff',
                                padding: '40px 0',
                                textAlign: 'center'
                            }}
                        >
                            <BarChartOutlined style={{ fontSize: '48px', color: '#64748b', marginBottom: '16px' }} />
                            <Title level={4} style={{ color: "var(--primary-text-color)", marginBottom: '8px' }}>Select a Physician</Title>
                            <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>
                                Choose a physician from the dropdown above to view their analytics dashboard.
                            </Text>
                        </Card>
                    )
                    )}
                </div>
            )}

            {viewType === 'ccm_coordinator' && (
                <div style={{ marginBottom: '32px' }}>
                    <Card 
                        style={{ 
                            borderRadius: '12px', 
                            border: '1px solid var(--border-color)', 
                            background: '#fff',
                            marginBottom: '24px'
                        }}
                    >
                        {user.role !== globalRoles.CCM_COORDINATOR && (
                        <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <LineChartOutlined style={{ fontSize: '24px', color: '#22c55e' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>CCM Coordinator Dashboard</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: "var(--secondary-text-color)" }}>
                            Select a coordinator to view their analytics
                        </Text>
                        
                        <Select 
                            value={selectedCoordinator?.id || undefined}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ 
                                width: '100%', 
                                marginBottom: '16px'
                            }}
                            dropdownStyle={{ 
                                borderRadius: '8px',
                                backgroundColor: 'var(--primary-bg)',
                                border: '1px solid var(--border-color)'
                            }}
                            onChange={(value) => {
                                const coordinator = coordinators.find(c => c.id === value);
                                if (coordinator) {
                                    setSelectedCoordinator(coordinator);
                                } else {
                                    console.error("Coordinator not found in list!");
                                }
                            }}
                            placeholder="Choose a coordinator..."
                            showSearch
                            filterOption={(input, option) => {
                                const text = option.children;
                                if (typeof text === 'string') {
                                    return text.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }}
                            notFoundContent="No coordinators available"
                            loading={coordinators.length === 0}
                        >
                            {coordinators.map(coordinator => (
                                <Select.Option key={coordinator.id} value={coordinator.id}>
                                    {coordinator.name} - {coordinator.email || 'CCM Coordinator'}
                                </Select.Option>
                            ))}
                        </Select>
                        </>
                        )}
                    
                        {/* <Card 
                            style={{ 
                                borderRadius: '12px', 
                                border: '1px solid var(--border-color)', 
                                background: '#fff'
                            }}
                        > */}
                            {/* <Title level={4} style={{ margin: 0, marginBottom: '8px', color: "var(--primary-text-color)" }}>{selectedCoordinator.name}</Title>
                            <Text type="secondary" style={{ color: "var(--secondary-text-color)", display: 'block', marginBottom: '20px' }}>
                                {selectedCoordinator.email || 'CCM Coordinator'}
                            </Text> */}
                            
                            <Row gutter={[16, 16]}>
                                <Col span={8}>
                                    <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#f0f5ff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                            <UsergroupAddOutlined style={{ fontSize: '20px', color: '#2563eb' }} />
                                            <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>{coordinatorDashboardData?.totalManagers || 0}</Text>
                                        </div>
                                        <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>CCM Managers</Text>
                                    </Card>
                                </Col>
                                <Col span={8}>
                                    <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#faf5ff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                            <UserOutlined style={{ fontSize: '20px', color: '#8a3ef4' }} />
                                            <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>
                                                {Array.isArray(coordinatorDashboardData?.totalPatientsManaged) && coordinatorDashboardData.totalPatientsManaged.length > 0 
                                                    ? coordinatorDashboardData.totalPatientsManaged[0]?.totalPatientsManaged || 0 
                                                    : 0}
                                            </Text>
                                        </div>
                                        <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>Total Patients Managed</Text>
                                    </Card>
                                </Col>
                                <Col span={8}>
                                    <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#fff0f3' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                            <SendOutlined style={{ fontSize: '20px', color: '#ef4444' }} />
                                            <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>
                                                {Array.isArray(coordinatorDashboardData?.totalVideosSent) && coordinatorDashboardData.totalVideosSent.length > 0 
                                                    ? coordinatorDashboardData.totalVideosSent[0]?.totalVideosSent || 0 
                                                    : 0}
                                            </Text>
                                        </div>
                                        <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>Total Videos Sent</Text>
                                    </Card>
                                </Col>
                            </Row>
                        {/* </Card> */}
                        </Card>
                </div>
            )}

            {viewType === 'ccm_group' && (
                <div style={{ marginBottom: '32px' }}>
                    <Card
                        style={{
                            borderRadius: '12px',
                            border: '1px solid var(--border-color)',
                            background: '#fff',
                            marginBottom: '24px'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <UsergroupAddOutlined style={{ fontSize: '24px', color: '#10b981' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>CCM Group Dashboard</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: "var(--secondary-text-color)" }}>
                            Select a CCM group to view its analytics
                        </Text>
                        <Select
                            value={selectedCcmGroup?._id || selectedCcmGroup?.id || undefined}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ width: '100%', marginBottom: '16px' }}
                            onChange={(value) => {
                                const group = ccmGroups.find(g => (g._id || g.id) === value);
                                if (group) setSelectedCcmGroup(group);
                            }}
                            placeholder="Choose a CCM group..."
                            showSearch
                            filterOption={(input, option) => {
                                const text = option.children;
                                return typeof text === 'string' && text.toLowerCase().includes(input.toLowerCase());
                            }}
                            notFoundContent="No CCM groups available"
                            loading={ccmGroups.length === 0}
                        >
                            {ccmGroups.map(group => (
                                <Select.Option key={group._id || group.id} value={group._id || group.id}>
                                    {group.hospitalName || group.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Card>
                </div>
            )}

            {viewType === 'ccm_manager' && (
                <div style={{ marginBottom: '32px' }}>
                    <Card 
                        style={{ 
                            borderRadius: '12px', 
                            border: '1px solid var(--border-color)', 
                            background: '#fff',
                            marginBottom: '24px'
                        }}
                    >
                        {user.role !== globalRoles.CCM_MANAGER && (
                        <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <LineChartOutlined style={{ fontSize: '24px', color: '#22c55e' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>CCM Manager Dashboard</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: "var(--secondary-text-color)" }}>
                            Select a manager to view their analytics
                        </Text>
                        
                        <Select 
                            value={selectedManager?._id || undefined}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ 
                                width: '100%', 
                                marginBottom: '16px'
                            }}
                            dropdownStyle={{ 
                                borderRadius: '8px',
                                backgroundColor: 'var(--primary-bg)',
                                border: '1px solid var(--border-color)'
                            }}
                            onChange={(value) => {
                                const manager = managers.find(m => m._id === value);
                                if (manager) {
                                    setSelectedManager(manager);
                                } else {
                                    console.error("Manager not found in list!");
                                }
                            }}
                            placeholder="Choose a manager..."
                            showSearch
                            filterOption={(input, option) => {
                                const text = option.children;
                                if (typeof text === 'string') {
                                    return text.toLowerCase().includes(input.toLowerCase());
                                }
                                return false;
                            }}
                            notFoundContent="No managers available"
                            loading={managers.length === 0}
                        >
                            {managers.map(manager => (
                                <Select.Option key={manager._id} value={manager._id}>
                                    {manager.name} - {manager.email || 'CCM Manager'}
                                </Select.Option>
                            ))}
                        </Select>
                        </>
                        )}
                    
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#f0f5ff' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                        <UsergroupAddOutlined style={{ fontSize: '20px', color: '#2563eb' }} />
                                        <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>{coordinatorDashboardData?.totalManagers || 0}</Text>
                                    </div>
                                    <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>CCM Managers</Text>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#faf5ff' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                        <UserOutlined style={{ fontSize: '20px', color: '#8a3ef4' }} />
                                        <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>
                                            {Array.isArray(coordinatorDashboardData?.totalPatientsManaged) && coordinatorDashboardData.totalPatientsManaged.length > 0 
                                                ? coordinatorDashboardData.totalPatientsManaged[0]?.totalPatientsManaged || 0 
                                                : 0}
                                        </Text>
                                    </div>
                                    <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>Total Patients Managed</Text>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ borderRadius: '8px', border: '1px solid var(--border-color)', background: '#fff0f3' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                        <SendOutlined style={{ fontSize: '20px', color: '#ef4444' }} />
                                        <Text strong style={{ fontSize: '24px', color: 'var(--primary-text-color)' }}>
                                            {Array.isArray(coordinatorDashboardData?.totalVideosSent) && coordinatorDashboardData.totalVideosSent.length > 0 
                                                ? coordinatorDashboardData.totalVideosSent[0]?.totalVideosSent || 0 
                                                : 0}
                                        </Text>
                                    </div>
                                    <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>Total Videos Sent</Text>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </div>
            )}
            {((viewType === 'physician_view' && (selectedPhysician || user?.role === globalRoles.PHYSICIAN)) || viewType !== 'physician_view') && (
                <>
                {/* Debug: This content should show when physician is selected */}
                <div style={{ marginBottom: '24px' }}>
                <Segmented
                    block
                    value={selectedTab}
                    onChange={setSelectedTab}
                    options={[
                        { label: viewType.startsWith('ccm') ? 'CCM' : 'Clinical', value: 'Patient Survey' },
                        'QR Codes',
                        'Reports',
                        ...(viewType === 'clinical_lead' ? ['Group Physicians'] :
                            viewType === 'physician_view' ? ['Performance'] :
                            viewType === 'ccm_coordinator' ? ['CCM Managers'] :
                            viewType === 'ccm_manager' ? [] :
                            viewType === 'clinical_module' ? ['Schedulers'] :
                            [])
                    ]}
                    style={{ 
                        backgroundColor: '#f1f5f9',
                        padding: '4px',
                        borderRadius: '5px'
                    }}
                />
            </div>

            {selectedTab === 'Patient Survey' && (
                <>
                <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                {loading ? (
                    Array.from({ length: 5 }).map((_, index) => (
                        <Col key={index} className="five-col">
                            <Card style={{ borderRadius: '12px', border: '1px solid var(--border-color)' }}>
                                <Skeleton active paragraph={{ rows: 2 }} title={false} />
                            </Card>
                        </Col>
                    ))
                ) : (
                    statsData.map((stat, index) => (
                        <Col key={index} className="five-col">
                            <StatCard 
                                label={stat.label} 
                                value={stat.value} 
                                diff={stat.diff} 
                                icon={stat.icon} 
                            />
                        </Col>
                    ))
                )}
                </Row>

            {/* Clinical-specific summary metrics */}
             {!viewType.includes('ccm') && viewType !== 'physician_view' && (
                 <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                     <Col lg={8} md={8} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#f5f3ff" borderColor="#ddd6fe" color="#8a3ef4">
                             <div className="summary-label">Completion Rate</div>
                             <div className="summary-value">
                                 {clinicalDashboardData?.completionRate 
                                     ? `${clinicalDashboardData.completionRate.toFixed(1)}%`
                                     : dashboardAnalytics?.totalClicks > 0 
                                     ? `${((dashboardAnalytics?.totalViews / dashboardAnalytics?.totalClicks) * 100).toFixed(1)}%`
                                     : '0.0%'}
                             </div>
                             <div className="summary-subtext">of clicked videos completed</div>
                         </ClinicalSummaryCard>
                     </Col>
                     <Col lg={8} md={8} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#f0fdf4" borderColor="#bbf7d0" color="#10b981">
                             <div className="summary-label">Avg Survey Score</div>
                             <div className="summary-value">
                                 {clinicalDashboardData?.avgSurveyScore 
                                     ? clinicalDashboardData.avgSurveyScore.toFixed(2)
                                     : analyticsData?.overallAverage || '0.00'}
                             </div>
                             <div className="summary-subtext">out of 5.0</div>
                         </ClinicalSummaryCard>
                     </Col>
                     <Col lg={8} md={8} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#eff6ff" borderColor="#bfdbfe" color="#3b82f6">
                             <div className="summary-label">Avg Time to Complete</div>
                             <div className="summary-value">
                                 {clinicalDashboardData?.avgTimeToComplete 
                                     ? clinicalDashboardData.avgTimeToComplete
                                     : dashboardAnalytics?.totalViews > 0 
                                     ? `${Math.floor(dashboardAnalytics?.totalWatchTime / dashboardAnalytics?.totalViews)}:${(Math.floor((dashboardAnalytics?.totalWatchTime / dashboardAnalytics?.totalViews * 60) % 60)).toString().padStart(2, '0')}`
                                     : '0:00'}
                             </div>
                             <div className="summary-subtext">minutes per video</div>
                         </ClinicalSummaryCard>
                     </Col>
                 </Row>
             )}

             {/* CCM-specific summary metrics */}
             {viewType.includes('ccm') && viewType !== 'physician_view' && (
                 <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                     <Col lg={6} md={12} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#f5f3ff" borderColor="#ddd6fe" color="#8a3ef4">
                             <div className="summary-label">Total CCM Plans</div>
                             <div className="summary-value">
                                 {ccmDashboardData?.totalPlans || '0'}
                             </div>
                             <div className="summary-subtext">active this month</div>
                         </ClinicalSummaryCard>
                     </Col>
                     <Col lg={6} md={12} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#f0fdf4" borderColor="#bbf7d0" color="#10b981">
                             <div className="summary-label">Patients Enrolled</div>
                             <div className="summary-value">
                                 {ccmDashboardData?.patientsEnrolled || '0'}
                             </div>
                             <div className="summary-subtext">in CCM program</div>
                         </ClinicalSummaryCard>
                     </Col>
                     <Col lg={6} md={12} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#eff6ff" borderColor="#bfdbfe" color="#3b82f6">
                             <div className="summary-label">Avg Min/Patient</div>
                             <div className="summary-value">
                                 {ccmDashboardData?.avgMinutesPerPatient || '0'}
                             </div>
                             <div className="summary-subtext">minutes per patient</div>
                         </ClinicalSummaryCard>
                     </Col>
                     <Col lg={6} md={12} sm={24} xs={24}>
                         <ClinicalSummaryCard bgColor="#fffbeb" borderColor="#fef3c7" color="#d97706">
                             <div className="summary-label">Avg Survey Score</div>
                             <div className="summary-value">
                                 {ccmDashboardData?.avgSurveyScore 
                                     ? ccmDashboardData.avgSurveyScore.toFixed(2)
                                     : analyticsData?.overallAverage || '0.00'}
                             </div>
                             <div className="summary-subtext">out of 5.0</div>
                         </ClinicalSummaryCard>
                     </Col>
                 </Row>
             )}

             {/* CCM Charts Section - Videos Sent & Enrollment + Patient Enrollment by Group */}
             {viewType.includes('ccm') && (
                <>
                <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <div 
                            style={{ 
                                background: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                borderRadius: "12px",
                                padding: "24px",
                                height: "100%"
                            }}
                        >
                            <SectionHeader>
                                <SendOutlined className="section-icon" />
                                <Title level={4}>Videos Sent & Enrollment by Group</Title>
                            </SectionHeader>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                Videos sent and patients enrolled per group
                            </Text>
                            <div style={{ height: '300px' }}>
                                <Column {...ccmGroupEngagementConfig} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <div 
                            style={{ 
                                background: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                borderRadius: "12px",
                                padding: "24px",
                                height: "100%"
                            }}
                        >
                            <SectionHeader>
                                <UsergroupAddOutlined className="section-icon" />
                                <Title level={4}>Patient Enrollment by Group</Title>
                            </SectionHeader>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                CCM patient enrollment distribution across groups
                            </Text>
                            <div style={{ height: '300px' }}>
                                <Pie {...ccmEnrollmentPieConfig} />
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* CCM Monthly Trends Chart */}
                <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                    <Col span={24}>
                        <div 
                            style={{ 
                                background: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                borderRadius: "12px",
                                padding: "24px"
                            }}
                        >
                            <SectionHeader>
                                <LineChartOutlined className="section-icon" />
                                <Title level={4}>CCM Monthly Trends</Title>
                            </SectionHeader>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                6-month performance trends for CCM program
                            </Text>
                            <div style={{ height: '300px' }}>
                                <Line {...ccmMonthlyTrendsConfig} />
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* CCM Activity by Manager Table */}
                <div 
                    style={{ 
                        marginBottom: '32px',
                        background: "var(--primary-bg)",
                        border: "1px solid var(--border-color)",
                        borderRadius: "12px",
                        padding: "24px"
                    }}
                >
                    <SectionHeader>
                        <UserOutlined className="section-icon" />
                        <Title level={4}>CCM Activity by Manager</Title>
                    </SectionHeader>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Individual CCM manager video and enrollment tracking
                    </Text>
                    
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ borderBottom: '2px solid var(--border-color)' }}>
                                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>CCM Manager</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Role</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Videos Sent</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Patients Enrolled</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Total Plans</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Total Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ccmManagerActivity && ccmManagerActivity.length > 0 ? (
                                    ccmManagerActivity.map((manager, index) => (
                                        <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                            <td style={{ padding: '16px', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                {capitalizeFirstLetter(manager.name || 'N/A')}
                                            </td>
                                            <td style={{ padding: '16px', fontSize: '14px', color: 'var(--secondary-text-color)' }}>
                                                <Tag style={{ borderRadius: '20px',background: "transparent", border: '1px solid var(--border-color)', color: 'var(--primary-text-color)', fontSize: '12px', fontWeight: 600 }}>
                                                    {manager.role || 'CCM Manager'}
                                                </Tag>
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#8a3ef4' }}>
                                                {manager.videosSent || 0}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                                {manager.enrolledPatients || 0}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                {manager.totalPlans || 0}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                {manager.totalTime || '0h 0m'}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: 'var(--secondary-text-color)' }}>
                                            No CCM manager activity data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* CCM Activity by Group Table */}
                {viewType === 'ccm_group' && (
                <div 
                    style={{ 
                        marginBottom: '32px',
                        background: "var(--primary-bg)",
                        border: "1px solid var(--border-color)",
                        borderRadius: "12px",
                        padding: "24px"
                    }}
                >
                    <SectionHeader>
                        <FileTextOutlined className="section-icon" />
                        <Title level={4}>CCM Activity by Group</Title>
                    </SectionHeader>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Group-level CCM video and enrollment summary
                    </Text>
                    
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ borderBottom: '2px solid var(--border-color)' }}>
                                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Group</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Specialty</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Videos Sent</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Patients Enrolled</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Total Plans</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Total Time</th>
                                    <th style={{ padding: '12px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: 'var(--secondary-text-color)', textTransform: 'uppercase' }}>Surveys</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ccmGroupPerformance && ccmGroupPerformance.length > 0 ? (
                                    <>
                                        {ccmGroupPerformance.map((group, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                                <td style={{ padding: '16px', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {group.groupName || 'N/A'}
                                                </td>
                                                <td style={{ padding: '16px', fontSize: '14px', color: 'var(--secondary-text-color)' }}>
                                                    <Tag style={{ borderRadius: '20px', background: "transparent", border: '1px solid var(--border-color)', color: 'var(--primary-text-color)', fontSize: '12px', fontWeight: 600 }}>
                                                        {group.specialty || 'N/A'}
                                                    </Tag>
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#8a3ef4' }}>
                                                    {group.videosSent || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                                    {group.patientsEnrolled || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {group.totalPlans || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {group.totalTime || '0h 0m'}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {group.surveys || 0}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr style={{ borderTop: '2px solid var(--border-color)', background: 'var(--border-color)' }}>
                                            <td style={{ padding: '16px', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                Total
                                            </td>
                                            <td style={{ padding: '16px' }}></td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#8a3ef4' }}>
                                                {ccmGroupPerformance.reduce((sum, g) => sum + (g.videosSent || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                                {ccmGroupPerformance.reduce((sum, g) => sum + (g.patientsEnrolled || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                {ccmGroupPerformance.reduce((sum, g) => sum + (g.totalPlans || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                {(() => {
                                                    const totalMinutes = ccmGroupPerformance.reduce((sum, g) => {
                                                        const time = String(g.totalTime || '0h 0m');
                                                        const match = time.match(/(\d+)h\s*(\d+)m/);
                                                        if (match) {
                                                            return sum + (parseInt(match[1]) * 60) + parseInt(match[2]);
                                                        }
                                                        return sum;
                                                    }, 0);
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;
                                                    return `${hours}h ${minutes}m`;
                                                })()}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                {ccmGroupPerformance.reduce((sum, g) => sum + (g.surveys || 0), 0)}
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: 'var(--secondary-text-color)' }}>
                                            No CCM group activity data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                )}
                </>
             )}

             {/* Charts Section - Engagement Funnel & Monthly Trends */}
             {!viewType.includes('ccm') && viewType !== 'physician_view' && (
                <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <div 
                            style={{ 
                                background: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                borderRadius: "12px",
                                padding: "24px",
                                height: "100%"
                            }}
                        >
                            <SectionHeader>
                                <BarChartOutlined className="section-icon" />
                                <Title level={4}>Clinical Engagement Funnel</Title>
                            </SectionHeader>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                Patient journey from send to survey
                            </Text>
                            <div style={{ height: '300px' }}>
                                <Bar {...funnelConfig} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={12} md={24} sm={24} xs={24}>
                        <div 
                            style={{ 
                                background: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                borderRadius: "12px",
                                padding: "24px",
                                height: "100%"
                            }}
                        >
                            <SectionHeader>
                                <LineChartOutlined className="section-icon" />
                                <Title level={4}>Clinical Monthly Trends</Title>
                            </SectionHeader>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                Last 6 months performance
                            </Text>
                            <div style={{ height: '300px' }}>
                                <Line {...trendsConfig} />
                            </div>
                        </div>
                    </Col>
                </Row>
             )}

             {/* Top Clinical Videos - Only for Clinical Module and Clinical Lead */}
             {!viewType.includes('ccm') && viewType !== 'physician_view' && clinicalVideos.length > 0 && (
                <div 
                   style={{ 
                      marginBottom: '40px',
                      background: "var(--primary-bg)",
                      border: "1px solid var(--border-color)",
                      borderRadius: "12px",
                      padding: "16px 24px"
                    }}
                >
                    <SectionHeader>
                        <VideoCameraOutlined className="section-icon" />
                        <Title level={4}>Top Clinical Videos</Title>
                    </SectionHeader>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Most viewed clinical education videos
                    </Text>
                    
                    {clinicalVideos.map((video, index) => (
                        <VideoCard key={index}>
                            <div className="video-info">
                                <div className="rank-circle">{index + 1}</div>
                                <div className="details">
                                    <div className="name">{video.videoName}</div>
                                    <div className="meta">
                                        <span className="specialty-tag">{video.videoSpecialty || 'Clinical'}</span>
                                        <span className="views">{video.clickedCount || 0} views</span>
                                    </div>
                                </div>
                            </div>
                            <div className="rating">
                                <StarFilled className="star-icon" />
                                {video.avgRating || (3.5 + Math.random()).toFixed(1)}
                            </div>
                        </VideoCard>
                    ))}
                </div>
             )}

                {/* Patient Survey Feedback - Always visible in Patient Survey tab */}
                {selectedTab === 'Patient Survey' && (
                <div style={{ marginTop: '24px' }}>
                    <SectionHeader>
                        <MessageOutlined className="section-icon" />
                        <Title level={4}>Patient Survey Feedback</Title>
                    </SectionHeader>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Comprehensive patient satisfaction across 5 key dimensions
                    </Text>
                    
                    <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <div className="satisfaction-score-card" style={{ height: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <Text type="secondary" style={{ fontSize: '14px', display: 'block', marginBottom: '16px', color: "var(--secondary-text-color)" }}>
                                    Overall Satisfaction Score
                                </Text>
                                <div style={{ fontSize: '72px', fontWeight: '800', color: '#8a3ef4', lineHeight: '1', marginBottom: '8px' }}>
                                    {analyticsData?.overallAverage || '0.00'}
                                </div> 
                                <Text type="secondary" style={{ fontSize: '16px', color: "var(--secondary-text-color)" }}>out of 5.0</Text>
                            </div>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                            <div className="radar-chart-container" style={{ height: '320px' }}>
                                <Text style={{ fontSize: '16px', fontWeight: '600', display: 'block', marginBottom: '24px', color: "var(--primary-text-color)" }}>
                                    Response Distribution
                                </Text>
                                <div style={{ height: '220px' }}>
                                    <Radar key={analyticsData ? 'loaded' : 'empty'} {...radarConfig} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    
                    <SurveyQuestionContainer>
                        {analyticsData?.perQuestion?.map((survey, index) => {
                            const getQuestionConfig = (qNum) => {
                                switch (qNum) {
                                    case 1:
                                        return {
                                            icon: BulbOutlined,
                                            labels: ['Very Confident', 'Confident', 'Somewhat Confident', 'Not Very Confident', 'Not Confident at All']
                                        };
                                    case 2:
                                        return {
                                            icon: LikeOutlined,
                                            labels: ['Much More Helpful', 'More Helpful', 'About the Same', 'Somewhat Less Helpful', 'Less Helpful']
                                        };
                                    case 3:
                                        return {
                                            icon: CheckCircleOutlined,
                                            labels: ['Yes, Definitely', 'Somewhat', 'Not at All']
                                        };
                                    case 4:
                                        return {
                                            icon: PlayCircleOutlined,
                                            labels: ['Significantly Reduced', 'Somewhat Reduced', 'No Change', 'Slightly Increased', 'Increased Anxiety']
                                        };
                                    case 5:
                                        return {
                                            icon: MessageOutlined,
                                            labels: ['Yes', 'Not Sure', 'No']
                                        };
                                    default:
                                        return {
                                            icon: MessageOutlined,
                                            labels: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']
                                        };
                                }
                            };

                            const config = getQuestionConfig(survey.questionNumber);
                            const formattedOptions = survey.options
                                .filter(opt => opt.index <= config.labels.length)
                                .map(opt => ({
                                    label: config.labels[opt.index - 1],
                                    count: opt.count,
                                    percent: opt.percentage
                                }));

                            return (
                                <SurveyQuestion 
                                    key={index}
                                    question={survey.question}
                                    score={survey.averageRating?.toFixed(2)}
                                    responses={survey.totalResponses}
                                    icon={config.icon}
                                    options={formattedOptions}
                                />
                            );
                        })}
                    </SurveyQuestionContainer>
                </div>
                )}
            </>
            )}

            {selectedTab === 'QR Codes' && (
                <div style={{ padding: '24px', textAlign: 'center' }}>Feature Coming Soon!</div>
            )}
            {selectedTab === 'Reports' && (
                <div style={{ padding: '0px' }}>
                    {!viewType.startsWith('ccm') ? (
                        <ReportingSummaryCard>
                            <div className="report-header">
                                <FileTextOutlined className="report-icon" />
                                <Title level={4}>Clinical Reporting Summary</Title>
                            </div>
                            <Text className="report-subtitle">Clinical module metrics and custom reporting</Text>
                            
                            <div className="report-item">
                                <span className="label">Videos Sent</span>
                                <span className="value" style={{ color: '#8a3ef4' }}>{reportSummary?.videoSent || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Videos Clicked</span>
                                <span className="value" style={{ color: '#6366f1' }}>{reportSummary?.totalClicks || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Watch Time</span>
                                <span className="value" style={{ color: '#8a3ef4' }}>
                                    {reportSummary?.totalWatchTime > 0 
                                        ? `${Math.floor(reportSummary?.totalWatchTime)}:${(Math.floor((reportSummary?.totalWatchTime * 60) % 60)).toString().padStart(2, '0')}`
                                        : '0:00'}
                                </span>
                            </div>
                            <div className="report-item">
                                <span className="label">Videos Completed</span>
                                <span className="value" style={{ color: '#10b981' }}>{reportSummary?.completedVideos || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Patient Surveys</span>
                                <span className="value" style={{ color: '#f59e0b' }}>{reportSummary?.surveyCount || 0}</span>
                            </div>
                        </ReportingSummaryCard>
                    ) : (
                        <ReportingSummaryCard $isCcm>
                            <div className="report-header">
                                <FileTextOutlined className="report-icon" />
                                <Title level={4}>CCM Reporting Summary</Title>
                            </div>
                            <Text className="report-subtitle">CCM module metrics and custom reporting</Text>
                            
                            <div className="report-item">
                                <span className="label">Videos Sent</span>
                                <span className="value" style={{ color: '#10b981' }}>{reportSummary?.videoSent || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Videos Clicked</span>
                                <span className="value" style={{ color: '#3b82f6' }}>{reportSummary?.totalClicks || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Total Time</span>
                                <span className="value" style={{ color: '#8a3ef4' }}>
                                    {reportSummary?.totalWatchTime > 0 
                                        ? `${Math.floor(reportSummary?.totalWatchTime / 60)}h ${Math.floor(reportSummary?.totalWatchTime % 60)}m`
                                        : '0h 0m'}
                                </span>
                            </div>
                            <div className="report-item">
                                <span className="label">Patient Surveys</span>
                                <span className="value" style={{ color: '#f59e0b' }}>{reportSummary?.surveyCount || 0}</span>
                            </div>
                            <div className="report-item">
                                <span className="label">Patients Enrolled</span>
                                <span className="value" style={{ color: '#10b981' }}>{reportSummary?.totalEnrolled || 0}</span>
                            </div>
                        </ReportingSummaryCard>
                    )}

                    {/* Trend Charts Section */}
                    <Row gutter={[20, 20]} style={{ marginTop: '24px' }}>
                        <Col lg={12} md={24} sm={24} xs={24}>
                            <Card style={{ borderRadius: '12px', border: '1px solid var(--border-color)' }}>
                                <SectionHeader>
                                    <Title level={4}>
                                        {viewType.startsWith('ccm') ? 'CCM Videos Sent & Enrolled' : 'Clinical Videos Sent vs Completed'}
                                    </Title>
                                </SectionHeader>
                                <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
                                    {viewType.startsWith('ccm') ? '6-month video distribution and enrollment trends' : '6-month video engagement funnel'}
                                </Text>
                                <div style={{ height: '300px' }}>
                                    <Column {...(viewType.startsWith('ccm') ? ccmEngagementConfig : clinicalEngagementConfig)} />
                                </div>
                            </Card>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24}>
                            <Card style={{ borderRadius: '12px', border: '1px solid var(--border-color)' }}>
                                <SectionHeader>
                                    <Title level={4}>
                                        {viewType.startsWith('ccm') ? 'CCM Survey Trends' : 'Clinical Survey Trends'}
                                    </Title>
                                </SectionHeader>
                                <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
                                    Patient survey responses over time
                                </Text>
                                <div style={{ height: '300px' }}>
                                    <Line {...(viewType.startsWith('ccm') ? ccmSurveyTrendsConfig : clinicalSurveyTrendsConfig)} />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
            {selectedTab === 'Schedulers' && (
                <div 
                  style={{ 
                    // padding: '24px 0' 
                    background: "var(--primary-bg)",
                    border: "1px solid var(--border-color)",
                    borderRadius: "12px",
                    padding: "16px 24px"
                  }}
                >
                    <SectionHeader>
                        <Title level={4}>Top Schedulers Sending Videos</Title>
                    </SectionHeader>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '32px', color: "var(--secondary-text-color)" }}>
                        Staff members with highest video distribution
                    </Text>

                    {topSchedulers.length > 0 ? (
                        topSchedulers.map((scheduler, index) => (
                            <SchedulerCard key={index}>
                                <div className="scheduler-info">
                                    <div className="rank-circle">{index + 1}</div>
                                    <div className="details">
                                        <div className="name">{scheduler.scheduledBy || 'Staff Member'}</div>
                                        <div className="hospital">{scheduler.email || 'staff@meducate.com'}</div>
                                    </div>
                                </div>
                                <div className="metrics">
                                    <div className="metric-item videos-sent">
                                        <div className="value">{scheduler.totalVideoSend || 0}</div>
                                        <div className="label">Videos Sent</div>
                                    </div>
                                    <div className="metric-item patients">
                                        <div className="value">{scheduler.patients || 0}</div>
                                        <div className="label">Patients</div>
                                    </div>
                                    <div className="metric-item response-rate">
                                        <div className="value">{scheduler.responseRate || '0'}%</div>
                                        <div className="label">Response Rate</div>
                                    </div>
                                </div>
                            </SchedulerCard>
                        ))
                    ) : (
                        <Card className='TopScheduler'>
                            <Text className='textColor' type="secondary">No scheduler data available for this period</Text>
                        </Card>
                    )}
                </div>
            )}
            {selectedTab === 'Group Physicians' && (
                <div 
                    style={{ 
                        background: "var(--primary-bg)",
                        border: "1px solid var(--border-color)",
                        borderRadius: "12px",
                        padding: "24px"
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                        <LuStethoscope style={{ fontSize: '20px', color: '#8a3ef4' }} />
                        <Title level={4} style={{ margin: 0, color: 'var(--primary-text-color)' }}>
                            Physicians in {selectedGroup?.hospitalName || 'Clinical Group'}
                        </Title>
                    </div>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Analytics for all physicians under your clinical group leadership
                    </Text>
                    
                    {physicianPerformance && physicianPerformance.length > 0 ? (
                        physicianPerformance.map((physician, index) => (
                            <div 
                                key={index}
                                style={{ 
                                    background: "var(--primary-bg)",
                                    border: "1px solid var(--border-color)",
                                    borderLeft: "4px solid #8a3ef4",
                                    borderRadius: "8px",
                                    padding: "20px 24px",
                                    marginBottom: '16px',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderLeftColor = '#6366f1';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(138, 62, 244, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderLeftColor = '#8a3ef4';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                {/* Top Section: Name, Specialty, Hospital and Metrics in one row */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                    {/* Left: Physician Info */}
                                    <div>
                                        <Title level={5} style={{ margin: 0, marginBottom: '6px', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                            {physician.name || 'Dr. Unknown'}
                                        </Title>
                                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                            <Tag style={{ 
                                                borderRadius: '4px', 
                                                border: '1px solid var(--border-color)', 
                                                background: '#f0f5ff', 
                                                color: 'var(--primary-text-color)', 
                                                fontSize: '12px', 
                                                fontWeight: 600,
                                                padding: '2px 10px',
                                                margin: 0
                                            }}>
                                                {physician.specialty || 'Cardiology'}
                                            </Tag>
                                            <Text type="secondary" style={{ fontSize: '13px', color: 'var(--secondary-text-color)' }}>
                                                {physician.hospitalName || "General Hospital"}
                                            </Text>
                                        </div>
                                    </div>
                                    
                                    {/* Right: Metrics in horizontal row */}
                                    <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
                                        <div style={{ textAlign: 'center', minWidth: '70px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#8a3ef4', marginBottom: '2px', lineHeight: 1 }}>
                                                {physician.videosSent || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
                                                Videos Sent
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center', minWidth: '70px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#6366f1', marginBottom: '2px', lineHeight: 1 }}>
                                                {physician.totalClicks || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
                                                Clicks
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center', minWidth: '70px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#3b82f6', marginBottom: '2px', lineHeight: 1 }}>
                                                {physician.watchTime || '0:00'}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
                                                Watch Time
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center', minWidth: '70px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#10b981', marginBottom: '2px', lineHeight: 1 }}>
                                                {physician.completedCount || 0}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
                                                Completed
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center', minWidth: '70px' }}>
                                            <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b', marginBottom: '2px', lineHeight: 1 }}>
                                                {physician.completionRate || '0%'}
                                            </div>
                                            <div style={{ fontSize: '11px', color: 'var(--secondary-text-color)', fontWeight: 500 }}>
                                                Completion
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Bottom Section: Journeys and Patients */}
                                <div style={{ 
                                    display: 'flex',
                                    gap: '24px',
                                    fontSize: '13px',
                                    color: 'var(--primary-text-color)'
                                }}>
                                    <span>
                                        <strong style={{ fontWeight: 600 }}>Journeys:</strong> <span style={{ color: 'var(--primary-text-color)' }}>{physician.journey || 0}</span>
                                    </span>
                                    <span>
                                        <strong style={{ fontWeight: 600 }}>Patients Enrolled:</strong> <span style={{ color: 'var(--primary-text-color)' }}>{physician.patientsManaged || 0}</span>
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <Card style={{ textAlign: 'center', padding: '40px', borderRadius: '12px', border: '1px solid var(--border-color)' }}>
                            <UserOutlined style={{ fontSize: '48px', color: '#64748b', marginBottom: '16px' }} />
                            <Title level={4} style={{ color: "var(--primary-text-color)", marginBottom: '8px' }}>No Physician Data Available</Title>
                            <Text type="secondary" style={{ color: "var(--secondary-text-color)" }}>
                                No physician performance data found for this group.
                            </Text>
                        </Card>
                    )}
                </div>
            )}

            {selectedTab === 'Group Physicians' && physicianPerformance && physicianPerformance.length > 0 && (
                <div 
                    style={{ 
                        background: "var(--primary-bg)",
                        border: "1px solid var(--border-color)",
                        borderRadius: "12px",
                        padding: "24px",
                        marginTop: "24px"
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                        <BarChartOutlined style={{ fontSize: '20px', color: '#8a3ef4' }} />
                        <Title level={4} style={{ margin: 0, color: 'var(--primary-text-color)' }}>
                            Group Physician Comparison
                        </Title>
                    </div>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                        Side-by-side comparison of physician performance in your group
                    </Text>
                    
                    <div style={{ height: '300px' }}>
                        <Column {...getPhysicianComparisonConfig()} />
                    </div>
                </div>
            )}
            {selectedTab === 'CCM Managers' && (
                <>
                    <Card 
                        style={{ 
                            borderRadius: '12px', 
                            border: '1px solid var(--border-color)', 
                            background: '#fff',
                            marginTop: '24px'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                            <UsergroupAddOutlined style={{ fontSize: '24px', color: '#22c55e' }} />
                            <Title level={4} style={{ margin: 0, color: "var(--primary-text-color)" }}>CCM Managers Overview</Title>
                        </div>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                            All CCM managers under your coordination with their performance metrics
                        </Text>

                        {allCCMPerformance && allCCMPerformance.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {allCCMPerformance.map((manager, index) => (
                                    <Card 
                                        key={index}
                                        style={{ 
                                            borderRadius: '8px', 
                                            border: '1px solid var(--border-color)',
                                            borderLeft: '4px solid #22c55e',
                                            background: '#fff'
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <div style={{ flex: 1 }}>
                                                <Title level={5} style={{ margin: 0, marginBottom: '4px', color: "var(--primary-text-color)" }}>
                                                    {capitalizeFirstLetter(manager.name || 'Unknown Manager')}
                                                </Title>
                                                <Text type="secondary" style={{ fontSize: '13px', color: "var(--secondary-text-color)" }}>
                                                    CCM Manager
                                                </Text>
                                                <div style={{ marginTop: '8px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                    {manager.groupsAssigned && manager.groupsAssigned.length > 0 ? (
                                                        manager.groupsAssigned.map((program, idx) => (
                                                            <Tag 
                                                                key={idx}
                                                                style={{ 
                                                                    borderRadius: '12px', 
                                                                    background: '#f0fdf4', 
                                                                    border: '1px solid #86efac',
                                                                    color: '#166534',
                                                                    fontSize: '12px'
                                                                }}
                                                            >
                                                                {program}
                                                            </Tag>
                                                        ))
                                                    ) : (
                                                        <Tag 
                                                            style={{ 
                                                                borderRadius: '12px', 
                                                                background: '#f0fdf4', 
                                                                border: '1px solid #86efac',
                                                                color: '#166534',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            General CCM Program
                                                        </Tag>
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Text strong style={{ fontSize: '24px', color: '#10b981', display: 'block' }}>
                                                        {manager.patientsManaged || 0}
                                                    </Text>
                                                    <Text type="secondary" style={{ fontSize: '12px', color: "var(--secondary-text-color)" }}>
                                                        Patients Managed
                                                    </Text>
                                                </div>
                                                <div style={{ width: '1px', height: '40px', background: 'var(--border-color)' }}></div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Text strong style={{ fontSize: '24px', color: '#8a3ef4', display: 'block' }}>
                                                        {manager.videosSent || 0}
                                                    </Text>
                                                    <Text type="secondary" style={{ fontSize: '12px', color: "var(--secondary-text-color)" }}>
                                                        Videos Sent
                                                    </Text>
                                                </div>
                                                <div style={{ width: '1px', height: '40px', background: 'var(--border-color)' }}></div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Text strong style={{ fontSize: '24px', color: '#f59e0b', display: 'block' }}>
                                                        {manager.surveysDone || 0}
                                                    </Text>
                                                    <Text type="secondary" style={{ fontSize: '12px', color: "var(--secondary-text-color)" }}>
                                                        Surveys Done
                                                    </Text>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--secondary-text-color)' }}>
                                <UsergroupAddOutlined style={{ fontSize: '48px', color: '#d1d5db', marginBottom: '16px' }} />
                                <Text type="secondary" style={{ display: 'block', color: "var(--secondary-text-color)" }}>
                                    No CCM managers data available
                                </Text>
                            </div>
                        )}
                    </Card>

                    {/* CCM Manager Performance Comparison Chart */}
                    {allCCMPerformance && allCCMPerformance.length > 0 && (
                        <Card 
                            style={{ 
                                borderRadius: '12px',
                                border: '1px solid var(--border-color)', 
                                background: '#fff',
                                marginTop: '24px'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                                <BarChartOutlined style={{ fontSize: '20px', color: '#22c55e' }} />
                                <Title level={4} style={{ margin: 0, color: 'var(--primary-text-color)' }}>
                                    CCM Manager Performance Comparison
                                </Title>
                            </div>
                            <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: "var(--secondary-text-color)" }}>
                                Compare all CCM managers by videos sent, patients managed, and survey completion
                            </Text>
                            
                            <div style={{ height: '350px' }}>
                                <Column {...getCCMManagerComparisonConfig()} />
                            </div>
                        </Card>
                    )}

                    {/* CCM Manager Summary Table */}
                    {allCCMPerformance && allCCMPerformance.length > 0 && (
                        <Card 
                            style={{ 
                                borderRadius: '12px',
                                border: '1px solid var(--border-color)', 
                                background: '#fff',
                                marginTop: '24px'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                                <FileTextOutlined style={{ fontSize: '20px', color: '#22c55e' }} />
                                <Title level={4} style={{ margin: 0, color: 'var(--primary-text-color)' }}>
                                    CCM Manager Summary Table
                                </Title>
                            </div>
                            
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ borderBottom: '2px solid var(--border-color)', background: 'var(--border-color)' }}>
                                            <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Manager
                                            </th>
                                            <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Groups Assigned
                                            </th>
                                            <th style={{ padding: '14px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Patients
                                            </th>
                                            <th style={{ padding: '14px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Videos Sent
                                            </th>
                                            <th style={{ padding: '14px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Surveys
                                            </th>
                                            <th style={{ padding: '14px 16px', textAlign: 'center', fontSize: '13px', fontWeight: 700, color: 'var(--primary-text-color)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                Avg Videos/Patient
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allCCMPerformance.map((manager, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                                <td style={{ padding: '16px', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {capitalizeFirstLetter(manager.name || 'Unknown Manager')}
                                                </td>
                                                <td style={{ padding: '16px' }}>
                                                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                        {manager.groupsAssigned && manager.groupsAssigned.length > 0 ? (
                                                            manager.groupsAssigned.map((program, idx) => (
                                                                <Tag 
                                                                    key={idx}
                                                                    style={{ 
                                                                        borderRadius: '20px', 
                                                                        background: 'transparent', 
                                                                        border: '1px solid var(--border-color)',
                                                                        color: 'var(--primary-text-color)',
                                                                        fontSize: '11px',
                                                                        fontWeight: 600,
                                                                        margin: 0,
                                                                        padding: '2px 8px'
                                                                    }}
                                                                >
                                                                    {program}
                                                                </Tag>
                                                            ))
                                                        ) : ("-")}
                                                    </div>
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                                    {manager.patientsManaged || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#8a3ef4' }}>
                                                    {manager.videosSent || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#f59e0b' }}>
                                                    {manager.surveysDone || 0}
                                                </td>
                                                <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 600, color: 'var(--primary-text-color)' }}>
                                                    {manager.avgVideosPerPatient 
                                                        ? manager.avgVideosPerPatient.toFixed(1)
                                                        : '0.0'}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr style={{ borderTop: '2px solid var(--border-color)', background: 'var(--border-color)' }}>
                                            <td style={{ padding: '16px', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                Total
                                            </td>
                                            <td style={{ padding: '16px' }}></td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#10b981' }}>
                                                {allCCMPerformance.reduce((sum, m) => sum + (m.patientsManaged || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#8a3ef4' }}>
                                                {allCCMPerformance.reduce((sum, m) => sum + (m.videosSent || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '16px', fontWeight: 700, color: '#f59e0b' }}>
                                                {allCCMPerformance.reduce((sum, m) => sum + (m.surveysDone || 0), 0)}
                                            </td>
                                            <td style={{ padding: '16px', textAlign: 'center', fontSize: '15px', fontWeight: 700, color: 'var(--primary-text-color)' }}>
                                                {(() => {
                                                    const totalPatients = allCCMPerformance.reduce((sum, m) => sum + (m.patientsManaged || 0), 0);
                                                    const totalVideos = allCCMPerformance.reduce((sum, m) => sum + (m.videosSent || 0), 0);
                                                    return totalPatients > 0 ? (totalVideos / totalPatients).toFixed(1) : '0.0';
                                                })()}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    )}
                </>
            )}
            {selectedTab === 'Performance' && (
                <div>
                    <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
                        {/* Year-to-Date Performance */}
                        <Col lg={12} md={24} sm={24} xs={24}>
                            <Card 
                                style={{ 
                                    borderRadius: '12px', 
                                    border: '1px solid var(--border-color)',
                                    height: '100%'
                                }}
                            >
                                <Title level={4} style={{ color: 'var(--primary-text-color)', marginBottom: '8px' }}>
                                    Year-to-Date Performance
                                </Title>
                                <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: 'var(--secondary-text-color)' }}>
                                    Cumulative metrics for {new Date().getFullYear()}
                                </Text>
                                
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {[
                                        { label: 'Total Videos', value: physicianIndividualPerformance?.ytd?.totalVideos || 0 },
                                        { label: 'Voice Recordings', value: physicianIndividualPerformance?.ytd?.voiceRecordings || 0 },
                                        { label: 'Video Views', value: physicianIndividualPerformance?.ytd?.videoViews ? `${(physicianIndividualPerformance.ytd.videoViews / 1000).toFixed(1)}K` : '0' },
                                        { label: 'Video Clicks', value: physicianIndividualPerformance?.ytd?.videoClicks ? `${(physicianIndividualPerformance.ytd.videoClicks / 1000).toFixed(1)}K` : '0' },
                                        // { label: 'QR Code Clicks', value: physicianIndividualPerformance?.ytd?.qrCodeClicks || 0 },
                                        // { label: 'QR Code Scans', value: physicianIndividualPerformance?.ytd?.qrCodeScans ? `${(physicianIndividualPerformance.ytd.qrCodeScans / 1000).toFixed(1)}K` : '0' },
                                        { label: 'Videos Sent', value: physicianIndividualPerformance?.ytd?.videosSent || 0 },
                                        { label: 'Videos Watched', value: physicianIndividualPerformance?.ytd?.videosWatched ? `${(physicianIndividualPerformance.ytd.videosWatched / 1000).toFixed(1)}K` : '0' }
                                    ].map((metric, index) => (
                                        <div 
                                            key={index}
                                            style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center',
                                                padding: '12px 0',
                                                borderBottom: index < 7 ? '1px solid var(--border-color)' : 'none'
                                            }}
                                        >
                                            <Text style={{ color: 'var(--primary-text-color)', fontSize: '14px' }}>
                                                {metric.label}
                                            </Text>
                                            <Text strong style={{ color: 'var(--primary-text-color)', fontSize: '16px' }}>
                                                {metric.value}
                                            </Text>
                                        </div>
                                    ))}
                                </div>
                            </Card>
                        </Col>

                        {/* All-Time Statistics */}
                        <Col lg={12} md={24} sm={24} xs={24}>
                            <Card 
                                style={{ 
                                    borderRadius: '12px', 
                                    border: '1px solid var(--border-color)',
                                    height: '100%'
                                }}
                            >
                                <Title level={4} style={{ color: 'var(--primary-text-color)', marginBottom: '8px' }}>
                                    All-Time Statistics
                                </Title>
                                <Text type="secondary" style={{ display: 'block', marginBottom: '24px', color: 'var(--secondary-text-color)' }}>
                                    Total lifetime metrics
                                </Text>
                                
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {[
                                        { label: 'Total Videos', value: physicianIndividualPerformance?.lifetime?.totalVideos || 0 },
                                        { label: 'Voice Recordings', value: physicianIndividualPerformance?.lifetime?.voiceRecordings || 0 },
                                        { label: 'Video Views', value: physicianIndividualPerformance?.lifetime?.videoViews ? `${(physicianIndividualPerformance.allTime.videoViews / 1000).toFixed(1)}K` : '0' },
                                        { label: 'Video Clicks', value: physicianIndividualPerformance?.lifetime?.videoClicks ? `${(physicianIndividualPerformance.allTime.videoClicks / 1000).toFixed(1)}K` : '0' },
                                        // { label: 'QR Code Clicks', value: physicianIndividualPerformance?.allTime?.qrCodeClicks ? `${(physicianIndividualPerformance.allTime.qrCodeClicks / 1000).toFixed(1)}K` : '0' },
                                        // { label: 'QR Code Scans', value: physicianIndividualPerformance?.allTime?.qrCodeScans ? `${(physicianIndividualPerformance.allTime.qrCodeScans / 1000).toFixed(1)}K` : '0' },
                                        { label: 'Videos Sent', value: physicianIndividualPerformance?.lifetime?.videosSent ? `${(physicianIndividualPerformance.allTime.videosSent / 1000).toFixed(1)}K` : '0' },
                                        { label: 'Videos Watched', value: physicianIndividualPerformance?.lifetime?.videosWatched ? `${(physicianIndividualPerformance.allTime.videosWatched / 1000).toFixed(1)}K` : '0' }
                                    ].map((metric, index) => (
                                        <div 
                                            key={index}
                                            style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center',
                                                padding: '12px 0',
                                                borderBottom: index < 7 ? '1px solid var(--border-color)' : 'none'
                                            }}
                                        >
                                            <Text style={{ color: 'var(--primary-text-color)', fontSize: '14px' }}>
                                                {metric.label}
                                            </Text>
                                            <Text strong style={{ color: 'var(--primary-text-color)', fontSize: '16px' }}>
                                                {metric.value}
                                            </Text>
                                        </div>
                                    ))}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
            </>
            )}
        </PageWrapper>
    );
};

export default AnalyticsPage;
